import {
  ApiPaths,
  DashboardService,
  ErpApiService
} from "../../utils/ApiService";
import {
  GET_DASHBOARD_DATA_ORM,
  GET_PROJECT_FILTER_ORM,
  GET_RESPONSIBLE_FILTER_ORM,
  GET_ACCOUNTABLE_FILTER_ORM,
  GET_PROJECT_BD_OWNER_FILTER_ORM,
  GET_PROJECT_PROPOSAL_OWNER_FILTER_ORM,
  GET_LIAISON_PROCESS_DATA_ORM,
  GET_LIAISON_PROCESS_ORM,
  GET_LIAISON_PROCESS_ORM_EXPORT,
  GET_LIAISON_PROCESS_SUMMARY_ORM,
  GET_LIAISON_PROCESS_SUMMARY_ORM_EXPORT,
  GET_LIAISON_TASK_PLAN_ORM,
  GET_LIAISON_TASK_PLAN_ORM_EXPORT,
  GET_LIAISON_DOCUMENTATION_DATA_ORM,
  GET_LIAISON_DOCUMENTATION_SUMMARY_ORM,
  GET_LIAISON_DOCUMENTATION_SUMMARY_ORM_EXPORT,
  GET_LIAISON_DOCUMENTATION_ORM,
  GET_LEGAL_DATA_ORM,
  GET_LEGAL_SUMMARY_ORM,
  GET_LEGAL1_DATA_ORM,
  GET_LEGAL1_SUMMARY_ORM,
  GET_LEGAL1_ORM,
  GET_LEGAL_ORM,
  GET_COURT_CASE_DATA_ORM,
  GET_COURT_CASE_SUMMARY_ORM,
  GET_COURT_CASE_ORM,
  GET_PROJECT_PROGRESS_DASHBOARD_ORM,
  GET_BUSINESS_DEVELOPMENT_DATA_ORM,
  GET_PROJECT_PLAN_DELAY_REASON,
  GET_PROJECT_PLAN_CHANGE_HISTORY,
  GET_SALES_DATA_ORM,
  GET_SALES_SUMMARY_ORM,
  GET_SALES_ORM,
  GET_CP_SALES_DATA_ORM,
  GET_CP_SALES_SUMMARY_ORM,
  GET_CP_SALES_ORM,
  GET_PRE_SALES_DATA_ORM,
  GET_PRE_SALES_SUMMARY_ORM,
  GET_PRE_SALES_ORM,
  GET_CANCELLATION_SALES_DATA_ORM,
  GET_CANCELLATION_SALES_SUMMARY_ORM,
  GET_CANCELLATION_SALES_ORM,
  GET_COLLECTION_DATA_ORM,
  GET_COLLECTION_SUMMARY_ORM,
  GET_COLLECTION_ORM,
  GET_AGREEMENT_DATA_ORM,
  GET_AGREEMENT_SUMMARY_ORM,
  GET_AGREEMENT_SUMMARY_ORM_EXPORT,
  GET_AGREEMENT_ORM,
  GET_REGISTRATION_DATA_ORM,
  GET_REGISTRATION_SUMMARY_ORM,
  GET_REGISTRATION_SUMMARY_ORM_EXPORT,
  GET_REGISTRATION_ORM,
  GET_CUSTOMER_DATA_ORM,
  GET_CUSTOMER_SUMMARY_ORM,
  GET_CUSTOMER_ORM,
  GET_MARKETING_DATA_ORM,
  GET_MARKETING_SUMMARY_ORM,
  GET_MARKETING_ORM,
  GET_MARKETING_FUNNEL_DATA_ORM,
  GET_MARKETING_FUNNEL_SUMMARY_ORM,
  GET_MARKETING_FUNNEL_ORM,
  GET_SURVEY_DATA_ORM,
  GET_BUSINESS_DEVELOPMENT_DATA_ORM1,
  GET_SURVEY_SUMMARY_ORM,
  GET_SURVEY_ORM,
  GET_ACTION_FOR_BD,
  GET_ACTION_FOR_LIAISON_PROCESS,
  GET_ACTION_FOR_LIAISON_DOCUMENTATION,
  GET_ACTION_FOR_SURVEY,
  GET_ACTION_FOR_BOUNDARY_DISPUTE,
  GET_ACTION_FOR_COURT_CASE,
  GET_ACTION_FOR_LEGAL_TASK,
  GET_ACTION_FOR_MARKETING,
  GET_ACTION_FOR_PRE_SALES,
  GET_ACTION_FOR_SALES,
  GET_ACTION_FOR_CP_SALES,
  GET_ACTION_FOR_CANCELLATION,
  GET_ACTION_FOR_COLLECTION,
  GET_ACTION_FOR_AGREEMENT,
  GET_ACTION_FOR_REGISTRATION,
  GET_ACTION_FOR_CUSTOMER_TICKET,
  GET_ACTION_FOR_PROCUREMENT_PLAN,
  GET_ACTION_FOR_STOCK_SUMMARY,
  GET_PROCUREMENT_DATA_ORM,
  GET_PROCUREMENT_SUMMARY_ORM,
  GET_PROCUREMENT_ORM,
  GET_STORE_DATA_ORM,
  GET_STORE_SUMMARY_ORM,
  GET_STORE_ORM,
  GET_ACTION_FOR_CIVIL_INITIATION,
  GET_ACTION_FOR_CIVIL_PROCESS,
  GET_ACTION_FOR_HR,
  GET_ACTION_FOR_COMPLIANCE,
  GET_HR_ORM,
  GET_ACTION_FOR_APF,
  GET_ACTION_FOR_PROJECT_LOAN,
  GET_ACTION_FOR_PROJECT_HANDOVER,
  GET_PROJECT_HANDOVER_DATA_ORM,
  GET_PROJECT_HANDOVER_SUMMARY_ORM,
  GET_PROJECT_HANDOVER_ORM,
  GET_CIVIL_DATA_ORM,
  GET_CIVIL_INITIATION_DATA_ORM,
  GET_PROJECT_LOAN_SUMMARY_ORM,
  GET_APF_TASK_PLAN_REPORT_ORM,
  GET_PROCURMENT_PLAN_DATA_ORM,
  GET_PROJECT_PROGRESS_VIDEO,
  GET_AGREEMENT_ORM_EXPORT,
  GET_SURVEY_SKETCH_DASHBOARD,
  GET_REGISTRATION_ORM_EXPORT,
  GET_PROCURMENT_PLAN_ORM,
  GET_ACTION_FOR_PROCUREMENT_OUTSTANDING,
  GET_PROCURMENT_PLAN_SUMMARY_ORM,
  // Inventory Site
  GET_SITE_INVENTORY_DATA_ORM,
  GET_SITE_INVENTORY_ORM,
  GET_ACTION_FOR_SITE_INVENTORY,
  GET_SITE_INVENTORY_ORM_EXPORT,
  GET_PROJECT_LAND_BANK_ORM_EXPORT,
  // Inventory Land
  GET_PROJECT_LAND_BANK_DATA_ORM,
  GET_PROJECT_LAND_BANK_DATA_ORM1,
  GET_PROJECT_LAND_BANK_ORM,
  GET_ACTION_FOR_LAND_BANK_ORM,
  GET_APF_TASK_PLAN_REPORT_ORM_EXPORT,
  GET_APF_TASK_PLAN_QUERY_ORM,
  GET_CIVIL_PROJECT_PROGRESS_DATA_ORM,
  GET_CIVIL_PROJECT_BUDGET_DATA_ORM,
  GET_APF_TASK_PLAN_REPORT_PANEL_ORM,
  GET_PROJECT_LOAN_DATA_ORM,
  GET_ACTION_FOR_COLLECTION_PROJECTION,
  GET_COLLECTION_PROJECTION_DATA_ORM,
  GET_COLLECTION_OUTSTANDING,
  GET_COLLECTION_PROJECTION_SUMMARY_ORM,
  GET_COLLECTION_PROJECTION_ORM,
  GET_ACTION_FOR_SCHEDULE,
  GET_ACTION_FOR_BUDGET,
  GET_QC_ORM,
  GET_QC_ORM_EXPORT,
  GET_ACTION_FOR_QC,
  GET_QC_SUMMARY_ORM,
  GET_QC_DATA_ORM,
  GET_QC_INSPECTION_DATA_ORM,
  GET_QC_OBSERVATION_DATA_ORM,
  GET_QC_TRAINING_DATA_ORM,
  GET_QC_WALKTHROUGH_DATA_ORM,
  GET_QC_INSPECTION_ORM,
  GET_QC_OBSERVATION_ORM,
  GET_QC_TRAINING_ORM,
  GET_QC_WALKTHROUGH_ORM,
  GET_APF_TASK_PLAN_REPORT_BANK_ORM,
  GET_AGREEMENT_ORM_CARD,
  GET_REGISTRATION_ORM_CARD,
  GET_COLLECTION_PROJECTION_ORM_EXPORT,
  GET_COLLECTION_ORM_EXPORT,
  GET_ACCOUNT_INVOICE_DATA,
  GET_ACCOUNT_INVOICE_SUMMARY,
  GET_ACCOUNT_INVOICE,
  GET_ACCOUNT_MARKETING_DATA,
  GET_ACCOUNT_MARKETING_SUMMARY,
  GET_ACCOUNT_MARKETING,
  //CRM User Dashboard
  GET_CRM_DEPARTMENT_DASHBOARD_DATA,
  GET_CRM_PAYMENT_OUTSTANDING_DATA,
  GET_CRM_PAYMENT_OUTSTANDING_SUMMARY,
  GET_CRM_PAYMENT_OUTSTANDING_INFO,
  GET_CRM_PAYMENT_OUTSTANDING_DETAIL,
  GET_CRM_PAYMENT_RECEIVABLE_DATA,
  GET_CRM_PAYMENT_RECEIVABLE_DETAIL,
  GET_CRM_PAYMENT_RECEIVED_DATA,
  GET_CRM_PAYMENT_RECEIVED_DETAIL,
  GET_CRM_PAYMENT_REFUND,
  GET_CRM_PAYMENT_OUTSTANDING_ITEM
} from "./types";
import {
  mainLoadingTrue,
  mainLoadingFalse,
  dashBoardLoadingTrue,
  dashBoardLoadingFalse,
  displayMessage
} from "../User/action";
import { getItem } from "../../utils/crypto";

const userLocal = getItem("enuseloc");
const LoginuserId =
  userLocal && Object.keys(userLocal).length > 0 ? userLocal["user_id"] : null;

export const getDashboardDataOrm_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    department: "",
    projectPhaseID: "",
    fromDate: "",
    toDate: "",
    projectId: [],
    iDisplayStart: 0,
    iDisplayLength: -1,

    ...data
  };

  return (dispatch) => {
    dispatch(mainLoadingTrue());
    dispatch(dashBoardLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_DASHBOARD_DATA_ORM,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        dispatch(dashBoardLoadingFalse());
        if (!data.error) {
          dispatch(getDashboardDataOrmSuccess(data?.dashboardData));
        } else {
          dispatch(getDashboardDataOrmSuccess([]));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getDashboardDataOrmSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};

export const getDashboardDataOrmSuccess = (data) => {
  return {
    type: GET_DASHBOARD_DATA_ORM,
    payload: data
  };
};

export const getProjectFilterORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectPhaseID: "",
    responsibleID: "",
    accountableID: "",
    reportID: "",
    ...data
  };

  return (dispatch) => {
    dispatch(mainLoadingTrue());
    dispatch(dashBoardLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_PROJECT_FILTER_ORM,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        dispatch(dashBoardLoadingFalse());
        if (!data.error) {
          dispatch(getProjectFilterORMSuccess(data));
        } else {
          dispatch(getProjectFilterORMSuccess([]));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getProjectFilterORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};

export const getProjectFilterORMSuccess = (data) => {
  return {
    type: GET_PROJECT_FILTER_ORM,
    payload: data
  };
};

export const getResponsibleFilterORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectPhaseID: "",
    responsibleID: "",
    accountableID: "",
    dataReferenceID: "",
    reportID: "",
    dataTypeID: "",
    projectId: [],
    ...data
  };

  return (dispatch) => {
    dispatch(mainLoadingTrue());
    dispatch(dashBoardLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_RESPONSIBLE_FILTER_ORM,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        dispatch(dashBoardLoadingFalse());
        if (!data.error) {
          dispatch(getResponsibleFilterORMSuccess(data));
        } else {
          dispatch(getResponsibleFilterORMSuccess([]));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getResponsibleFilterORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};

export const getResponsibleFilterORMSuccess = (data) => {
  return {
    type: GET_RESPONSIBLE_FILTER_ORM,
    payload: data
  };
};

export const getAccountableFilterORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectPhaseID: "",
    responsibleID: "",
    accountableID: "",
    dataReferenceID: "",
    reportID: "",
    dataTypeID: "",
    projectId: [],
    ...data
  };

  return (dispatch) => {
    dispatch(mainLoadingTrue());
    dispatch(dashBoardLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_ACCOUNTABLE_FILTER_ORM,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        dispatch(dashBoardLoadingFalse());
        if (!data.error) {
          dispatch(getAccountableFilterORMSuccess(data));
        } else {
          dispatch(getAccountableFilterORMSuccess([]));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getAccountableFilterORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};

export const getAccountableFilterORMSuccess = (data) => {
  return {
    type: GET_ACCOUNTABLE_FILTER_ORM,
    payload: data
  };
};

export const getProjectBdOwnerFilterORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectPhaseID: "",
    responsibleID: "",
    accountableID: "",
    reportID: "",
    projectId: [],
    ...data
  };

  return (dispatch) => {
    dispatch(mainLoadingTrue());
    dispatch(dashBoardLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_PROJECT_BD_OWNER_FILTER_ORM,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        dispatch(dashBoardLoadingFalse());
        if (!data.error) {
          dispatch(getProjectBdOwnerFilterORMSuccess(data));
        } else {
          dispatch(getProjectBdOwnerFilterORMSuccess([]));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getProjectBdOwnerFilterORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};

export const getProjectBdOwnerFilterORMSuccess = (data) => {
  return {
    type: GET_PROJECT_BD_OWNER_FILTER_ORM,
    payload: data
  };
};

export const getProjectProposalOwnerFilterORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectPhaseID: "",
    responsibleID: "",
    accountableID: "",
    reportID: "",
    projectId: [],
    ...data
  };

  return (dispatch) => {
    dispatch(mainLoadingTrue());
    dispatch(dashBoardLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_PROJECT_PROPOSAL_OWNER_FILTER_ORM,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        dispatch(dashBoardLoadingFalse());
        if (!data.error) {
          dispatch(getProjectProposalOwnerFilterORMSuccess(data));
        } else {
          dispatch(getProjectProposalOwnerFilterORMSuccess([]));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getProjectProposalOwnerFilterORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};

export const getProjectProposalOwnerFilterORMSuccess = (data) => {
  return {
    type: GET_PROJECT_PROPOSAL_OWNER_FILTER_ORM,
    payload: data
  };
};

export const getLiaisonProcessSummaryORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    projectId: [],
    accountableID: "",
    responsibleID: "",
    projectPhaseID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: 10,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_LIAISON_PROCESS_SUMMARY_ORM,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getLiaisonProcessSummaryORMSuccess(data));
        } else {
          dispatch(getLiaisonProcessSummaryORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getLiaisonProcessSummaryORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getLiaisonProcessSummaryORMSuccess = (data) => {
  return {
    type: GET_LIAISON_PROCESS_SUMMARY_ORM,
    payload: data
  };
};

export const getLiaisonProcessSummaryORMEXPORT_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    projectPhaseID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: 10,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_LIAISON_PROCESS_SUMMARY_ORM,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getLiaisonProcessSummaryORMEXPORTSuccess(data));
        } else {
          dispatch(getLiaisonProcessSummaryORMEXPORTSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getLiaisonProcessSummaryORMEXPORTSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getLiaisonProcessSummaryORMEXPORTSuccess = (data) => {
  return {
    type: GET_LIAISON_PROCESS_SUMMARY_ORM_EXPORT,
    payload: data
  };
};

export const getLiaisonProcessORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectPhaseID: "",
    projectID: "",
    projectId: [],
    responsibleID: "",
    accountableID: "",
    delayTypeID: "",
    dataTypeID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: 10,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_LIAISON_PROCESS_ORM,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getLiaisonProcessORMSuccess(data));
        } else {
          dispatch(getLiaisonProcessORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getLiaisonProcessORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getLiaisonProcessORMSuccess = (data) => {
  return {
    type: GET_LIAISON_PROCESS_ORM,
    payload: data
  };
};

export const getLiaisonProcessORMEXPORT_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectPhaseID: "",
    projectID: "",
    responsibleID: "",
    accountableID: "",
    dataTypeID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: 10,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_LIAISON_PROCESS_ORM,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getLiaisonProcessORMEXPORTSuccess(data));
        } else {
          dispatch(getLiaisonProcessORMEXPORTSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getLiaisonProcessORMEXPORTSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getLiaisonProcessORMEXPORTSuccess = (data) => {
  return { GET_LIAISON_PROCESS_ORM_EXPORT, payload: data };
};

export const getLiaisonTaskPlanORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    accountableID: "",
    responsibleID: "",
    projectId: [],
    projectPhaseID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: 10,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_LIAISON_TASK_PLAN_ORM,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getLiaisonTaskPlanORMSuccess(data));
        } else {
          dispatch(getLiaisonTaskPlanORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getLiaisonTaskPlanORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getLiaisonTaskPlanORMSuccess = (data) => {
  return {
    type: GET_LIAISON_TASK_PLAN_ORM,
    payload: data
  };
};

export const getLiaisonTaskPlanORMEXPORT_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    accountableID: "",
    responsibleID: "",
    projectPhaseID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: 10,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_LIAISON_TASK_PLAN_ORM,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getLiaisonTaskPlanORMEXPORTSuccess(data));
        } else {
          dispatch(getLiaisonTaskPlanORMEXPORTSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getLiaisonTaskPlanORMEXPORTSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getLiaisonTaskPlanORMEXPORTSuccess = (data) => {
  return { GET_LIAISON_TASK_PLAN_ORM_EXPORT, payload: data };
};

export const getLiaisonProcessDataORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectPhaseID: "",
    responsibleID: "",
    accountableID: "",
    projectID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: 10,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    dispatch(dashBoardLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_LIAISON_PROCESS_DATA_ORM,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        dispatch(dashBoardLoadingFalse());
        if (!data.error) {
          dispatch(getLiaisonProcessDataORMSuccess(data));
        } else {
          dispatch(getLiaisonProcessDataORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getLiaisonProcessDataORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getLiaisonProcessDataORMSuccess = (data) => {
  return {
    type: GET_LIAISON_PROCESS_DATA_ORM,
    payload: data
  };
};

export const getLiaisonDocumentationDataORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectPhaseID: "",
    responsibleID: "",
    accountableID: "",
    projectID: "",
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    dispatch(dashBoardLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_LIAISON_DOCUMENTATION_DATA_ORM,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        dispatch(dashBoardLoadingFalse());
        if (!data.error) {
          dispatch(getLiaisonDocumentationDataORMSuccess(data));
        } else {
          dispatch(getLiaisonDocumentationDataORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getLiaisonDocumentationDataORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getLiaisonDocumentationDataORMSuccess = (data) => {
  return {
    type: GET_LIAISON_DOCUMENTATION_DATA_ORM,
    payload: data
  };
};

export const getLiaisonDocumentationSummaryORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectPhaseID: "",
    responsibleID: "",
    accountableID: "",
    projectID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: 10,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_LIAISON_DOCUMENTATION_SUMMARY_ORM,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getLiaisonDocumentationSummaryORMSuccess(data));
        } else {
          dispatch(getLiaisonDocumentationSummaryORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getLiaisonDocumentationSummaryORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getLiaisonDocumentationSummaryORMSuccess = (data) => {
  return {
    type: GET_LIAISON_DOCUMENTATION_SUMMARY_ORM,
    payload: data
  };
};

export const getLiaisonDocumentationSummaryORMExport_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectPhaseID: "",
    responsibleID: "",
    accountableID: "",
    projectID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: -1,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_LIAISON_DOCUMENTATION_SUMMARY_ORM,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getLiaisonDocumentationSummaryORMExportSuccess(data));
        } else {
          dispatch(getLiaisonDocumentationSummaryORMExportSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getLiaisonDocumentationSummaryORMExportSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getLiaisonDocumentationSummaryORMExportSuccess = (data) => {
  return {
    type: GET_LIAISON_DOCUMENTATION_SUMMARY_ORM_EXPORT,
    payload: data
  };
};

export const getLiaisonDocumentationORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectPhaseID: "",
    responsibleID: "",
    accountableID: "",
    delayTypeID: "",
    dataTypeID: "",
    projectID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: 10,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_LIAISON_DOCUMENTATION_ORM,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getLiaisonDocumentationORMSuccess(data));
        } else {
          dispatch(getLiaisonDocumentationORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getLiaisonDocumentationORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getLiaisonDocumentationORMSuccess = (data) => {
  return {
    type: GET_LIAISON_DOCUMENTATION_ORM,
    payload: data
  };
};

export const getLegalDataORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectPhaseID: "",
    responsibleID: "",
    accountableID: "",
    projectID: "",
    categoryID: "Dispute",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: 10,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    dispatch(dashBoardLoadingTrue());
    return DashboardService.post(ApiPaths.GET_LEGAL_DATA_ORM, initialPayload)
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        dispatch(dashBoardLoadingFalse());
        if (!data.error) {
          dispatch(getLegalDataORMSuccess(data));
        } else {
          dispatch(getLegalDataORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getLegalDataORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getLegalDataORMSuccess = (data) => {
  return {
    type: GET_LEGAL_DATA_ORM,
    payload: data
  };
};

export const getLegalSummaryORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectPhaseID: "",
    responsibleID: "",
    accountableID: "",
    projectID: "",
    categoryID: "Dispute",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: 10,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(ApiPaths.GET_LEGAL_SUMMARY_ORM, initialPayload)
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getLegalSummaryORMSuccess(data));
        } else {
          dispatch(getLegalSummaryORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getLegalSummaryORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getLegalSummaryORMSuccess = (data) => {
  return {
    type: GET_LEGAL_SUMMARY_ORM,
    payload: data
  };
};

export const getLegalORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectPhaseID: "",
    responsibleID: "",
    accountableID: "",
    projectID: "",
    categoryID: "Legal",
    dataReferenceID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: 10,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(ApiPaths.GET_LEGAL_ORM, initialPayload)
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getLegalORMSuccess(data));
        } else {
          dispatch(getLegalORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getLegalORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getLegalORMSuccess = (data) => {
  return {
    type: GET_LEGAL_ORM,
    payload: data
  };
};

export const getLegal1DataORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectPhaseID: "",
    responsibleID: "",
    accountableID: "",
    projectID: "",
    categoryID: "Legal",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: 10,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    dispatch(dashBoardLoadingTrue());
    return DashboardService.post(ApiPaths.GET_LEGAL_DATA_ORM, initialPayload)
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        dispatch(dashBoardLoadingFalse());
        if (!data.error) {
          dispatch(getLegal1DataORMSuccess(data));
        } else {
          dispatch(getLegal1DataORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getLegal1DataORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getLegal1DataORMSuccess = (data) => {
  return {
    type: GET_LEGAL1_DATA_ORM,
    payload: data
  };
};

export const getLegal1SummaryORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectPhaseID: "",
    responsibleID: "",
    accountableID: "",
    projectID: "",
    categoryID: "Legal",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: 10,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(ApiPaths.GET_LEGAL_SUMMARY_ORM, initialPayload)
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getLegal1SummaryORMSuccess(data));
        } else {
          dispatch(getLegal1SummaryORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getLegal1SummaryORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getLegal1SummaryORMSuccess = (data) => {
  return {
    type: GET_LEGAL1_SUMMARY_ORM,
    payload: data
  };
};

export const getLegal1ORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectPhaseID: "",
    responsibleID: "",
    accountableID: "",
    projectID: "",
    categoryID: "Legal",
    dataReferenceID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: 10,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(ApiPaths.GET_LEGAL_ORM, initialPayload)
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getLegal1ORMSuccess(data));
        } else {
          dispatch(getLegal1ORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getLegal1ORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getLegal1ORMSuccess = (data) => {
  return {
    type: GET_LEGAL1_ORM,
    payload: data
  };
};

export const getCourtCaseDataORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectPhaseID: "",
    responsibleID: "",
    accountableID: "",
    projectID: "",
    categoryID: "Legal",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: 10,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    dispatch(dashBoardLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_COURT_CASE_DATA_ORM,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        dispatch(dashBoardLoadingFalse());
        if (!data.error) {
          dispatch(getCourtCaseDataORMSuccess(data));
        } else {
          dispatch(getCourtCaseDataORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getCourtCaseDataORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getCourtCaseDataORMSuccess = (data) => {
  return {
    type: GET_COURT_CASE_DATA_ORM,
    payload: data
  };
};

export const getCourtCaseSummaryORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectPhaseID: "",
    responsibleID: "",
    accountableID: "",
    projectID: "",
    categoryID: "Legal",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: 10,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_COURT_CASE_SUMMARY_ORM,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getCourtCaseSummaryORMSuccess(data));
        } else {
          dispatch(getCourtCaseSummaryORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getCourtCaseSummaryORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getCourtCaseSummaryORMSuccess = (data) => {
  return {
    type: GET_COURT_CASE_SUMMARY_ORM,
    payload: data
  };
};

export const getCourtCaseORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectPhaseID: "",
    responsibleID: "",
    accountableID: "",
    projectID: "",
    categoryID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: 10,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(ApiPaths.GET_COURT_CASE_ORM, initialPayload)
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getCourtCaseORMSuccess(data));
        } else {
          dispatch(getCourtCaseORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getCourtCaseORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getCourtCaseORMSuccess = (data) => {
  return {
    type: GET_COURT_CASE_ORM,
    payload: data
  };
};

export const getProjectProgressDashboardORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    projectPhaseID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: -1,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_PROJECT_PROGRESS_DASHBOARD_ORM,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getProjectProgressDashboardORMSuccess(data));
        } else {
          dispatch(getProjectProgressDashboardORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getProjectProgressDashboardORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getProjectProgressDashboardORMSuccess = (data) => {
  return {
    type: GET_PROJECT_PROGRESS_DASHBOARD_ORM,
    payload: data
  };
};

export const getBusinessDevelopmentDataORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    projectPhaseID: "",
    bdOwnerID: "",
    proposalOwnerID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: -1,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    dispatch(dashBoardLoadingTrue());

    return DashboardService.post(
      ApiPaths.GET_BUSINESS_DEVELOPMENT_DATA_ORM,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        dispatch(dashBoardLoadingFalse());

        if (!data.error) {
          dispatch(getBusinessDevelopmentDataORMSuccess(data));
        } else {
          dispatch(getBusinessDevelopmentDataORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getBusinessDevelopmentDataORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getBusinessDevelopmentDataORMSuccess = (data) => {
  return {
    type: GET_BUSINESS_DEVELOPMENT_DATA_ORM,
    payload: data
  };
};

export const getBusinessDevelopmentDataORM1_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    projectPhaseID: "",
    bdOwnerID: "",
    proposalOwnerID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: 10,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_BUSINESS_DEVELOPMENT_DATA_ORM,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getBusinessDevelopmentDataORM1Success(data));
        } else {
          dispatch(getBusinessDevelopmentDataORM1Success({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getBusinessDevelopmentDataORM1Success([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getBusinessDevelopmentDataORM1Success = (data) => {
  return {
    type: GET_BUSINESS_DEVELOPMENT_DATA_ORM1,
    payload: data
  };
};

export const getProjectPlanDelayReason_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_PROJECT_PLAN_DELAY_REASON,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getProjectPlanDelayReasonSuccess(data));
        } else {
          dispatch(getProjectPlanDelayReasonSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getProjectPlanDelayReasonSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getProjectPlanDelayReasonSuccess = (data) => {
  return {
    type: GET_PROJECT_PLAN_DELAY_REASON,
    payload: data
  };
};

export const getProjectPlanChangeHistory_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_PROJECT_PLAN_CHANGE_HISTORY,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getProjectPlanChangeHistorySuccess(data));
        } else {
          dispatch(getProjectPlanChangeHistorySuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getProjectPlanChangeHistorySuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getProjectPlanChangeHistorySuccess = (data) => {
  return {
    type: GET_PROJECT_PLAN_CHANGE_HISTORY,
    payload: data
  };
};

export const getSurveyDataORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    fromDate: "",
    toDate: "",
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    dispatch(dashBoardLoadingTrue());
    return DashboardService.post(ApiPaths.GET_SURVEY_DATA_ORM, initialPayload)
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        dispatch(dashBoardLoadingFalse());
        if (!data.error) {
          dispatch(getSurveyDataORMSuccess(data));
        } else {
          dispatch(getSurveyDataORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getSurveyDataORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getSurveyDataORMSuccess = (data) => {
  return {
    type: GET_SURVEY_DATA_ORM,
    payload: data
  };
};

export const getSurveySummaryORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectPhaseID: "",
    salesPersonID: "",
    fromDate: "",
    toDate: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: -1,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_SURVEY_SUMMARY_ORM,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getSurveySummaryORMSuccess(data));
        } else {
          dispatch(getSurveySummaryORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getSurveySummaryORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getSurveySummaryORMSuccess = (data) => {
  return {
    type: GET_SURVEY_SUMMARY_ORM,
    payload: data
  };
};

export const getSurveyORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    projectPhaseID: "",
    salesPersonID: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: -1,
    fromDate: "",
    toDate: "",
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(ApiPaths.GET_SURVEY_ORM, initialPayload)
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getSurveyORMSuccess(data));
        } else {
          dispatch(getSurveyORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getSurveyORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getSurveyORMSuccess = (data) => {
  return {
    type: GET_SURVEY_ORM,
    payload: data
  };
};

export const getProjectHandOverDataORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    projectPhaseID: "",
    salesPersonID: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: -1,
    fromDate: "",
    toDate: "",
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    dispatch(dashBoardLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_PROJECT_HANDOVER_DATA_ORM,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        dispatch(dashBoardLoadingFalse());
        if (!data.error) {
          dispatch(getProjectHandOverDataORMSuccess(data));
        } else {
          dispatch(getProjectHandOverDataORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getProjectHandOverDataORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getProjectHandOverDataORMSuccess = (data) => {
  return {
    type: GET_PROJECT_HANDOVER_DATA_ORM,
    payload: data
  };
};

export const getProjectHandOverSummaryORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    projectPhaseID: "",
    salesPersonID: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: -1,
    fromDate: "",
    toDate: "",
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_PROJECT_HANDOVER_SUMMARY_ORM,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getProjectHandOverSummaryORMSuccess(data));
        } else {
          dispatch(getProjectHandOverSummaryORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getProjectHandOverSummaryORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getProjectHandOverSummaryORMSuccess = (data) => {
  return {
    type: GET_PROJECT_HANDOVER_SUMMARY_ORM,
    payload: data
  };
};

export const getProjectHandOverORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    projectPhaseID: "",
    salesPersonID: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: -1,
    fromDate: "",
    toDate: "",
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_PROJECT_HANDOVER_ORM,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getProjectHandOverORMSuccess(data));
        } else {
          dispatch(getProjectHandOverORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getProjectHandOverORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getProjectHandOverORMSuccess = (data) => {
  return {
    type: GET_PROJECT_HANDOVER_ORM,
    payload: data
  };
};

export const getCollectionProjectionDataORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    projectPhaseID: "",
    projectId: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: -1,
    fromDate: "",
    toDate: "",
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    dispatch(dashBoardLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_COLLECTION_PROJECTION_DATA_ORM,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getCollectionProjectionDataORMSuccess(data));
        } else {
          dispatch(getCollectionProjectionDataORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getCollectionProjectionDataORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getCollectionProjectionDataORMSuccess = (data) => {
  return {
    type: GET_COLLECTION_PROJECTION_DATA_ORM,
    payload: data
  };
};
//Action API's
export const getActionForBD_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    departmentID: "",
    accountableID: "",
    projectID: "",
    categoryType: "LandAcquisition",
    categoryID: 14,
    assignedToID: "",
    assignedByID: "",
    statusID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: -1,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return ErpApiService.post(ApiPaths.GET_ACTION_FOR_BD, initialPayload)
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getActionForBDSuccess(data));
        } else {
          dispatch(getActionForBDSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getActionForBDSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getActionForBDSuccess = (data) => {
  return {
    type: GET_ACTION_FOR_BD,
    payload: data
  };
};

export const getActionForLiaisonProcess_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    departmentID: "",
    accountableID: "",
    projectID: "",
    categoryType: "LandAcquisition",
    categoryID: 8,
    assignedToID: "",
    assignedByID: "",
    statusID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: -1,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return ErpApiService.post(
      ApiPaths.GET_ACTION_FOR_LIAISON_PROCESS,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getActionForLiaisonProcessSuccess(data));
        } else {
          dispatch(getActionForLiaisonProcessSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getActionForLiaisonProcessSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getActionForLiaisonProcessSuccess = (data) => {
  return {
    type: GET_ACTION_FOR_LIAISON_PROCESS,
    payload: data
  };
};

export const getActionForLiaisonDocumentation_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    departmentID: "",
    accountableID: "",
    projectID: "",
    categoryType: "LandAcquisition",
    categoryID: 9,
    assignedToID: "",
    assignedByID: "",
    statusID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: -1,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return ErpApiService.post(
      ApiPaths.GET_ACTION_FOR_LIAISON_DOCUMENTATION,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getActionForLiaisonDocumentationSuccess(data));
        } else {
          dispatch(getActionForLiaisonDocumentationSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getActionForLiaisonDocumentationSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getActionForLiaisonDocumentationSuccess = (data) => {
  return {
    type: GET_ACTION_FOR_LIAISON_DOCUMENTATION,
    payload: data
  };
};

export const getActionForSurvey_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    departmentID: "",
    accountableID: "",
    projectID: "",
    categoryType: "LandAcquisition",
    categoryID: 10,
    assignedToID: "",
    assignedByID: "",
    statusID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: -1,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return ErpApiService.post(ApiPaths.GET_ACTION_FOR_SURVEY, initialPayload)
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getActionForSurveySuccess(data));
        } else {
          dispatch(getActionForSurveySuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getActionForSurveySuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getActionForSurveySuccess = (data) => {
  return {
    type: GET_ACTION_FOR_SURVEY,
    payload: data
  };
};

export const getActionForBoundaryDispute_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    departmentID: "",
    accountableID: "",
    projectID: "",
    categoryType: "LandAcquisition",
    categoryID: 11,
    assignedToID: "",
    assignedByID: "",
    statusID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: -1,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return ErpApiService.post(
      ApiPaths.GET_ACTION_FOR_BOUNDARY_DISPUTE,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getActionForBoundaryDisputeSuccess(data));
        } else {
          dispatch(getActionForBoundaryDisputeSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getActionForBoundaryDisputeSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getActionForBoundaryDisputeSuccess = (data) => {
  return {
    type: GET_ACTION_FOR_BOUNDARY_DISPUTE,
    payload: data
  };
};

export const getActionForCourtCase_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    departmentID: "",
    accountableID: "",
    projectID: "",
    categoryType: "LandAcquisition",
    categoryID: 12,
    assignedToID: "",
    assignedByID: "",
    statusID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: -1,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return ErpApiService.post(
      ApiPaths.GET_ACTION_FOR_COURT_CASE,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getActionForCourtCaseSuccess(data));
        } else {
          dispatch(getActionForCourtCaseSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getActionForCourtCaseSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getActionForCourtCaseSuccess = (data) => {
  return {
    type: GET_ACTION_FOR_COURT_CASE,
    payload: data
  };
};

export const getActionForLegalTask_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    departmentID: "",
    accountableID: "",
    projectID: "",
    categoryType: "LandAcquisition",
    categoryID: 13,
    assignedToID: "",
    assignedByID: "",
    statusID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: -1,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return ErpApiService.post(
      ApiPaths.GET_ACTION_FOR_LEGAL_TASK,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getActionForLegalTaskSuccess(data));
        } else {
          dispatch(getActionForLegalTaskSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getActionForLegalTaskSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getActionForLegalTaskSuccess = (data) => {
  return {
    type: GET_ACTION_FOR_LEGAL_TASK,
    payload: data
  };
};

//ORM Sales

export const getSalesDataORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    fromDate: "",
    toDate: "",
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    dispatch(dashBoardLoadingTrue());
    return DashboardService.post(ApiPaths.GET_SALES_DATA_ORM, initialPayload)
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        dispatch(dashBoardLoadingFalse());
        if (!data.error) {
          dispatch(getSalesDataORMSuccess(data));
        } else {
          dispatch(getSalesDataORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getSalesDataORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getSalesDataORMSuccess = (data) => {
  return {
    type: GET_SALES_DATA_ORM,
    payload: data
  };
};

export const getSalesSummaryORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    fromDate: "",
    toDate: "",
    dataTypeID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: 10,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(ApiPaths.GET_SALES_SUMMARY_ORM, initialPayload)
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getSalesSummaryORMSuccess(data));
        } else {
          dispatch(getSalesSummaryORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getSalesSummaryORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getSalesSummaryORMSuccess = (data) => {
  return {
    type: GET_SALES_SUMMARY_ORM,
    payload: data
  };
};

export const getSalesORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    projectPhaseID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: 10,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(ApiPaths.GET_SALES_ORM, initialPayload)
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getSalesORMSuccess(data));
        } else {
          dispatch(getSalesORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getSalesORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getSalesORMSuccess = (data) => {
  return {
    type: GET_SALES_ORM,
    payload: data
  };
};

//CP Sales

export const getCPSalesDataORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    fromDate: "",
    toDate: "",
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    dispatch(dashBoardLoadingTrue());
    return DashboardService.post(ApiPaths.GET_CP_SALES_DATA_ORM, initialPayload)
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        dispatch(dashBoardLoadingFalse());
        if (!data.error) {
          dispatch(getCPSalesDataORMSuccess(data));
        } else {
          dispatch(getCPSalesDataORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getCPSalesDataORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getCPSalesDataORMSuccess = (data) => {
  return {
    type: GET_CP_SALES_DATA_ORM,
    payload: data
  };
};

export const getCPSalesSummaryORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    fromDate: "",
    toDate: "",
    dataTypeID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: 10,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_CP_SALES_SUMMARY_ORM,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getCPSalesSummaryORMSuccess(data));
        } else {
          dispatch(getCPSalesSummaryORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getCPSalesSummaryORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getCPSalesSummaryORMSuccess = (data) => {
  return {
    type: GET_CP_SALES_SUMMARY_ORM,
    payload: data
  };
};

export const getCPSalesORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    projectPhaseID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: 10,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(ApiPaths.GET_CP_SALES_ORM, initialPayload)
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getCPSalesORMSuccess(data));
        } else {
          dispatch(getCPSalesORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getCPSalesORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getCPSalesORMSuccess = (data) => {
  return {
    type: GET_CP_SALES_ORM,
    payload: data
  };
};

export const getPreSalesDataORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    fromDate: "",
    toDate: "",
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    dispatch(dashBoardLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_PRE_SALES_DATA_ORM,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        dispatch(dashBoardLoadingFalse());
        if (!data.error) {
          dispatch(getPreSalesDataORMSuccess(data));
        } else {
          dispatch(getPreSalesDataORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getPreSalesDataORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getPreSalesDataORMSuccess = (data) => {
  return {
    type: GET_PRE_SALES_DATA_ORM,
    payload: data
  };
};

export const getPreSalesSummaryORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    fromDate: "",
    toDate: "",
    dataTypeID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: 10,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_PRE_SALES_SUMMARY_ORM,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getPreSalesSummaryORMSuccess(data));
        } else {
          dispatch(getPreSalesSummaryORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getPreSalesSummaryORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};

export const getPreSalesSummaryORMSuccess = (data) => {
  return {
    type: GET_PRE_SALES_SUMMARY_ORM,
    payload: data
  };
};

export const getPreSalesORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    projectPhaseID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: 10,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(ApiPaths.GET_PRE_SALES_ORM, initialPayload)
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getPreSalesORMSuccess(data));
        } else {
          dispatch(getPreSalesORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getPreSalesORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getPreSalesORMSuccess = (data) => {
  return {
    type: GET_PRE_SALES_ORM,
    payload: data
  };
};

export const getCancellationSalesDataORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    fromDate: "",
    toDate: "",
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    dispatch(dashBoardLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_CANCELLATION_SALES_DATA_ORM,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        dispatch(dashBoardLoadingFalse());
        if (!data.error) {
          dispatch(getCancellationSalesDataORMSuccess(data));
        } else {
          dispatch(getCancellationSalesDataORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getCancellationSalesDataORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getCancellationSalesDataORMSuccess = (data) => {
  return {
    type: GET_CANCELLATION_SALES_DATA_ORM,
    payload: data
  };
};

export const getCancellationSalesSummaryORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    fromDate: "",
    toDate: "",
    dataTypeID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: 10,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_CANCELLATION_SALES_SUMMARY_ORM,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getCancellationSalesSummaryORMSuccess(data));
        } else {
          dispatch(getCancellationSalesSummaryORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getCancellationSalesSummaryORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getCancellationSalesSummaryORMSuccess = (data) => {
  return {
    type: GET_CANCELLATION_SALES_SUMMARY_ORM,
    payload: data
  };
};

export const getCancellationSalesORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    projectPhaseID: "",
    weekID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: 10,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_CANCELLATION_SALES_ORM,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getCancellationSalesORMSuccess(data));
        } else {
          dispatch(getCancellationSalesORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getCancellationSalesORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getCancellationSalesORMSuccess = (data) => {
  return {
    type: GET_CANCELLATION_SALES_ORM,
    payload: data
  };
};

export const getCollectionDataORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    fromDate: "",
    toDate: "",
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    dispatch(dashBoardLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_COLLECTION_DATA_ORM,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        dispatch(dashBoardLoadingFalse());
        if (!data.error) {
          dispatch(getCollectionDataORMSuccess(data));
        } else {
          dispatch(getCollectionDataORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getCollectionDataORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getCollectionDataORMSuccess = (data) => {
  return {
    type: GET_COLLECTION_DATA_ORM,
    payload: data
  };
};

export const getCollectionSummaryORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    fromDate: "",
    toDate: "",
    dataTypeID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: 10,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_COLLECTION_SUMMARY_ORM,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getCollectionSummaryORMSuccess(data));
        } else {
          dispatch(getCollectionSummaryORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getCollectionSummaryORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getCollectionSummaryORMSuccess = (data) => {
  return {
    type: GET_COLLECTION_SUMMARY_ORM,
    payload: data
  };
};

export const getCollectionORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    projectPhaseID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: 10,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(ApiPaths.GET_COLLECTION_ORM, initialPayload)
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getCollectionORMSuccess(data));
        } else {
          dispatch(getCollectionORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getCollectionORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getCollectionORMSuccess = (data) => {
  return {
    type: GET_COLLECTION_ORM,
    payload: data
  };
};

export const getCollectionORMExport_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    projectPhaseID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: -1,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(ApiPaths.GET_COLLECTION_ORM, initialPayload)
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getCollectionORMExportSuccess(data));
        } else {
          dispatch(getCollectionORMExportSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getCollectionORMExportSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getCollectionORMExportSuccess = (data) => {
  return {
    type: GET_COLLECTION_ORM_EXPORT,
    payload: data
  };
};

export const getCollectionOutstanding_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_COLLECTION_OUTSTANDING,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getCollectionOutstandingSuccess(data));
        } else {
          dispatch(getCollectionOutstandingSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getCollectionOutstandingSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getCollectionOutstandingSuccess = (data) => {
  return {
    type: GET_COLLECTION_OUTSTANDING,
    payload: data
  };
};

export const getAgreementDataORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    fromDate: "",
    toDate: "",
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_AGREEMENT_DATA_ORM,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getAgreementDataORMSuccess(data));
        } else {
          dispatch(getAgreementDataORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getAgreementDataORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getAgreementDataORMSuccess = (data) => {
  return {
    type: GET_AGREEMENT_DATA_ORM,
    payload: data
  };
};

export const getAgreementSummaryORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    fromDate: "",
    toDate: "",
    dataTypeID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: 10,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_AGREEMENT_SUMMARY_ORM,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getAgreementSummaryORMSuccess(data));
        } else {
          dispatch(getAgreementSummaryORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getAgreementSummaryORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getAgreementSummaryORMSuccess = (data) => {
  return {
    type: GET_AGREEMENT_SUMMARY_ORM,
    payload: data
  };
};

export const getAgreementSummaryORMExport_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    fromDate: "",
    toDate: "",
    dataTypeID: "",
    projectPhaseID: "",
    accountableID: "",
    responsibleID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: -1,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_AGREEMENT_SUMMARY_ORM,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getAgreementSummaryORMExportSuccess(data));
        } else {
          dispatch(getAgreementSummaryORMExportSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getAgreementSummaryORMExportSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getAgreementSummaryORMExportSuccess = (data) => {
  return {
    type: GET_AGREEMENT_SUMMARY_ORM_EXPORT,
    payload: data
  };
};

export const getAgreementORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    projectPhaseID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: 10,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(ApiPaths.GET_AGREEMENT_ORM, initialPayload)
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getAgreementORMSuccess(data));
        } else {
          dispatch(getAgreementORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getAgreementORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getAgreementORMSuccess = (data) => {
  return {
    type: GET_AGREEMENT_ORM,
    payload: data
  };
};

export const getAgreementORMCard_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    projectPhaseID: "",
    generalSearch: "",
    delayTypeID: "",
    dataTypeID: "",
    dependencyID: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: 10,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(ApiPaths.GET_AGREEMENT_ORM, initialPayload)
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getAgreementORMCardSuccess(data));
        } else {
          dispatch(getAgreementORMCardSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getAgreementORMCardSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getAgreementORMCardSuccess = (data) => {
  return {
    type: GET_AGREEMENT_ORM_CARD,
    payload: data
  };
};

export const getAgreementORMExport_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    projectPhaseID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: 10,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(ApiPaths.GET_AGREEMENT_ORM, initialPayload)
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getAgreementORMExportSuccess(data));
        } else {
          dispatch(getAgreementORMExportSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getAgreementORMExportSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getAgreementORMExportSuccess = (data) => {
  return {
    type: GET_AGREEMENT_ORM_EXPORT,
    payload: data
  };
};

export const getRegistrationDataORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    fromDate: "",
    toDate: "",
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_REGISTRATION_DATA_ORM,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getRegistrationDataORMSuccess(data));
        } else {
          dispatch(getRegistrationDataORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getRegistrationDataORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getRegistrationDataORMSuccess = (data) => {
  return {
    type: GET_REGISTRATION_DATA_ORM,
    payload: data
  };
};

export const getRegistrationSummaryORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    fromDate: "",
    toDate: "",
    dataTypeID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: 10,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_REGISTRATION_SUMMARY_ORM,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getRegistrationSummaryORMSuccess(data));
        } else {
          dispatch(getRegistrationSummaryORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getRegistrationSummaryORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getRegistrationSummaryORMSuccess = (data) => {
  return {
    type: GET_REGISTRATION_SUMMARY_ORM,
    payload: data
  };
};

export const getRegistrationSummaryORMExport_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    fromDate: "",
    toDate: "",
    dataTypeID: "",
    projectPhaseID: "",
    accountableID: "",
    responsibleID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: -1,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_REGISTRATION_SUMMARY_ORM,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getRegistrationSummaryORMExportSuccess(data));
        } else {
          dispatch(getRegistrationSummaryORMExportSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getRegistrationSummaryORMExportSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getRegistrationSummaryORMExportSuccess = (data) => {
  return {
    type: GET_REGISTRATION_SUMMARY_ORM_EXPORT,
    payload: data
  };
};

export const getRegistrationORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    projectPhaseID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: 10,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(ApiPaths.GET_REGISTRATION_ORM, initialPayload)
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getRegistrationORMSuccess(data));
        } else {
          dispatch(getRegistrationORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getRegistrationORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getRegistrationORMSuccess = (data) => {
  return {
    type: GET_REGISTRATION_ORM,
    payload: data
  };
};

export const getRegistrationORMCard_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    projectPhaseID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: 10,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(ApiPaths.GET_REGISTRATION_ORM, initialPayload)
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getRegistrationORMCardSuccess(data));
        } else {
          dispatch(getRegistrationORMCardSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getRegistrationORMCardSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getRegistrationORMCardSuccess = (data) => {
  return {
    type: GET_REGISTRATION_ORM_CARD,
    payload: data
  };
};
export const getRegistrationORMExport_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    projectPhaseID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: -1,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(ApiPaths.GET_REGISTRATION_ORM, initialPayload)
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getRegistrationORMExportSuccess(data));
        } else {
          dispatch(getRegistrationORMExportSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getRegistrationORMExportSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getRegistrationORMExportSuccess = (data) => {
  return {
    type: GET_REGISTRATION_ORM_EXPORT,
    payload: data
  };
};

export const getCustomerDataORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    fromDate: "",
    toDate: "",
    ticketTypeID: "",
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    dispatch(dashBoardLoadingTrue());
    return DashboardService.post(ApiPaths.GET_CUSTOMER_DATA_ORM, initialPayload)
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        dispatch(dashBoardLoadingFalse());
        if (!data.error) {
          dispatch(getCustomerDataORMSuccess(data));
        } else {
          dispatch(getCustomerDataORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getCustomerDataORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getCustomerDataORMSuccess = (data) => {
  return {
    type: GET_CUSTOMER_DATA_ORM,
    payload: data
  };
};

export const getCustomerSummaryORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    fromDate: "",
    toDate: "",
    dataTypeID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: 10,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_CUSTOMER_SUMMARY_ORM,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getCustomerSummaryORMSuccess(data));
        } else {
          dispatch(getCustomerSummaryORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getCustomerSummaryORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getCustomerSummaryORMSuccess = (data) => {
  return {
    type: GET_CUSTOMER_SUMMARY_ORM,
    payload: data
  };
};

export const getCustomerORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    ticketTypeID: "",
    dataTypeID: "",
    delayTypeID: "",
    responsibleID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: 10,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(ApiPaths.GET_CUSTOMER_ORM, initialPayload)
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getCustomerORMSuccess(data));
        } else {
          dispatch(getCustomerORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getCustomerORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getCustomerORMSuccess = (data) => {
  return {
    type: GET_CUSTOMER_ORM,
    payload: data
  };
};

export const getMarketingDataORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    fromDate: "",
    toDate: "",
    dataTypeID: "",
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    dispatch(dashBoardLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_MARKETING_DATA_ORM,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        dispatch(dashBoardLoadingFalse());
        if (!data.error) {
          dispatch(getMarketingDataORMSuccess(data));
        } else {
          dispatch(getMarketingDataORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getMarketingDataORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getMarketingDataORMSuccess = (data) => {
  return {
    type: GET_MARKETING_DATA_ORM,
    payload: data
  };
};

export const getMarketingSummaryORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    fromDate: "",
    toDate: "",
    dataTypeID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: 10,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_MARKETING_SUMMARY_ORM,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getMarketingSummaryORMSuccess(data));
        } else {
          dispatch(getMarketingSummaryORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getMarketingSummaryORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getMarketingSummaryORMSuccess = (data) => {
  return {
    type: GET_MARKETING_SUMMARY_ORM,
    payload: data
  };
};

export const getMarketingORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    projectPhaseID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: 10,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(ApiPaths.GET_MARKETING_ORM, initialPayload)
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getMarketingORMSuccess(data));
        } else {
          dispatch(getMarketingORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getMarketingORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getMarketingORMSuccess = (data) => {
  return {
    type: GET_MARKETING_ORM,
    payload: data
  };
};

export const getMarketingFunnelDataORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    fromDate: "",
    toDate: "",
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    dispatch(dashBoardLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_MARKETING_FUNNEL_DATA_ORM,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        dispatch(dashBoardLoadingFalse());
        if (!data.error) {
          dispatch(getMarketingFunnelDataORMSuccess(data));
        } else {
          dispatch(getMarketingFunnelDataORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getMarketingFunnelDataORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getMarketingFunnelDataORMSuccess = (data) => {
  return {
    type: GET_MARKETING_FUNNEL_DATA_ORM,
    payload: data
  };
};

export const getMarketingFunnelSummaryORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    fromDate: "",
    toDate: "",
    dataTypeID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: 10,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_MARKETING_FUNNEL_SUMMARY_ORM,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getMarketingFunnelSummaryORMSuccess(data));
        } else {
          dispatch(getMarketingFunnelSummaryORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getMarketingFunnelSummaryORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getMarketingFunnelSummaryORMSuccess = (data) => {
  return {
    type: GET_MARKETING_FUNNEL_SUMMARY_ORM,
    payload: data
  };
};

export const getMarketingFunnelORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    projectPhaseID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: 10,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_MARKETING_FUNNEL_ORM,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getMarketingFunnelORMSuccess(data));
        } else {
          dispatch(getMarketingFunnelORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getMarketingFunnelORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getMarketingFunnelORMSuccess = (data) => {
  return {
    type: GET_MARKETING_FUNNEL_ORM,
    payload: data
  };
};

//Marketing Action ORM
export const getActionForMarketing_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    departmentID: "",
    accountableID: "",
    projectID: "",
    categoryType: "Marketing",
    categoryID: 15,
    assignedToID: "",
    assignedByID: "",
    statusID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: -1,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return ErpApiService.post(ApiPaths.GET_ACTION_FOR_MARKETING, initialPayload)
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getActionForMarketingSuccess(data));
        } else {
          dispatch(getActionForMarketingSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getActionForMarketingSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getActionForMarketingSuccess = (data) => {
  return {
    type: GET_ACTION_FOR_MARKETING,
    payload: data
  };
};

export const getActionForPreSales_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    departmentID: "",
    accountableID: "",
    projectID: "",
    categoryType: "PreSales",
    categoryID: 16,
    assignedToID: "",
    assignedByID: "",
    statusID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: -1,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return ErpApiService.post(ApiPaths.GET_ACTION_FOR_PRE_SALES, initialPayload)
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getActionForPreSalesSuccess(data));
        } else {
          dispatch(getActionForPreSalesSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getActionForPreSalesSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getActionForPreSalesSuccess = (data) => {
  return {
    type: GET_ACTION_FOR_PRE_SALES,
    payload: data
  };
};

export const getActionForSales_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    departmentID: "",
    accountableID: "",
    projectID: "",
    categoryType: "Marketing",
    categoryID: 17,
    assignedToID: "",
    assignedByID: "",
    statusID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: -1,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return ErpApiService.post(ApiPaths.GET_ACTION_FOR_SALES, initialPayload)
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getActionForSalesSuccess(data));
        } else {
          dispatch(getActionForSalesSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getActionForSalesSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getActionForSalesSuccess = (data) => {
  return {
    type: GET_ACTION_FOR_SALES,
    payload: data
  };
};

export const getActionForCPSales_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    departmentID: "",
    accountableID: "",
    projectID: "",
    categoryType: "Marketing",
    categoryID: 18,
    assignedToID: "",
    assignedByID: "",
    statusID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: -1,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return ErpApiService.post(ApiPaths.GET_ACTION_FOR_CP_SALES, initialPayload)
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getActionForCPSalesSuccess(data));
        } else {
          dispatch(getActionForCPSalesSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getActionForCPSalesSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getActionForCPSalesSuccess = (data) => {
  return {
    type: GET_ACTION_FOR_CP_SALES,
    payload: data
  };
};

export const getActionForCancellation_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    departmentID: "",
    accountableID: "",
    projectID: "",
    categoryType: "CRM",
    categoryID: 19,
    assignedToID: "",
    assignedByID: "",
    statusID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: -1,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return ErpApiService.post(
      ApiPaths.GET_ACTION_FOR_CANCELLATION,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getActionForCancellationSuccess(data));
        } else {
          dispatch(getActionForCancellationSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getActionForCancellationSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getActionForCancellationSuccess = (data) => {
  return {
    type: GET_ACTION_FOR_CANCELLATION,
    payload: data
  };
};

export const getActionForCollection_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    departmentID: "",
    accountableID: "",
    projectID: "",
    categoryType: "CRM",
    categoryID: 20,
    assignedToID: "",
    assignedByID: "",
    statusID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: -1,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return ErpApiService.post(
      ApiPaths.GET_ACTION_FOR_COLLECTION,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getActionForCollectionSuccess(data));
        } else {
          dispatch(getActionForCollectionSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getActionForCollectionSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getActionForCollectionSuccess = (data) => {
  return {
    type: GET_ACTION_FOR_COLLECTION,
    payload: data
  };
};

export const getActionForAgreement_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    departmentID: "",
    accountableID: "",
    projectID: "",
    categoryType: "CRM",
    categoryID: 21,
    assignedToID: "",
    assignedByID: "",
    statusID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: -1,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return ErpApiService.post(ApiPaths.GET_ACTION_FOR_AGREEMENT, initialPayload)
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getActionForAgreementSuccess(data));
        } else {
          dispatch(getActionForAgreementSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getActionForAgreementSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getActionForAgreementSuccess = (data) => {
  return {
    type: GET_ACTION_FOR_AGREEMENT,
    payload: data
  };
};

export const getActionForRegistration_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    departmentID: "",
    accountableID: "",
    projectID: "",
    categoryType: "CRM",
    categoryID: 22,
    assignedToID: "",
    assignedByID: "",
    statusID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: -1,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return ErpApiService.post(
      ApiPaths.GET_ACTION_FOR_REGISTRATION,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getActionForRegistrationSuccess(data));
        } else {
          dispatch(getActionForRegistrationSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getActionForRegistrationSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getActionForRegistrationSuccess = (data) => {
  return {
    type: GET_ACTION_FOR_REGISTRATION,
    payload: data
  };
};

export const getActionForCustomerTicket_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    departmentID: "",
    accountableID: "",
    projectID: "",
    categoryType: "CRM",
    categoryID: 23,
    assignedToID: "",
    assignedByID: "",
    statusID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: -1,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return ErpApiService.post(
      ApiPaths.GET_ACTION_FOR_CUSTOMER_TICKET,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getActionForCustomerTicketSuccess(data));
        } else {
          dispatch(getActionForCustomerTicketSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getActionForCustomerTicketSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getActionForCustomerTicketSuccess = (data) => {
  return {
    type: GET_ACTION_FOR_CUSTOMER_TICKET,
    payload: data
  };
};

export const getActionForProjectHandover_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    departmentID: "",
    accountableID: "",
    projectID: "",
    categoryType: "CRM",
    categoryID: 32,
    assignedToID: "",
    assignedByID: "",
    statusID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: -1,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return ErpApiService.post(
      ApiPaths.GET_ACTION_FOR_PROJECT_HANDOVER,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getActionForProjectHandoverSuccess(data));
        } else {
          dispatch(getActionForProjectHandoverSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getActionForProjectHandoverSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getActionForProjectHandoverSuccess = (data) => {
  return {
    type: GET_ACTION_FOR_PROJECT_HANDOVER,
    payload: data
  };
};

export const getActionForCollectionProjection_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    departmentID: "",
    accountableID: "",
    projectID: "",
    categoryType: "CRM",
    categoryID: 36,
    assignedToID: "",
    assignedByID: "",
    statusID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: -1,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return ErpApiService.post(
      ApiPaths.GET_ACTION_FOR_COLLECTION_PROJECTION,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getActionForCollectionProjectionSuccess(data));
        } else {
          dispatch(getActionForCollectionProjectionSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err  ", err);
        dispatch(getActionForCollectionProjectionSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getActionForCollectionProjectionSuccess = (data) => {
  return {
    type: GET_ACTION_FOR_COLLECTION_PROJECTION,
    payload: data
  };
};
//Procurement Action ORM
export const getActionForProcurementPlan_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    departmentID: "",
    accountableID: "",
    projectID: "",
    categoryType: "Procurement",
    categoryID: 26,
    assignedToID: "",
    assignedByID: "",
    statusID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: -1,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return ErpApiService.post(
      ApiPaths.GET_ACTION_FOR_PROCUREMENT_PLAN,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getActionForProcurementPlanSuccess(data));
        } else {
          dispatch(getActionForProcurementPlanSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getActionForProcurementPlanSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getActionForProcurementPlanSuccess = (data) => {
  return {
    type: GET_ACTION_FOR_PROCUREMENT_PLAN,
    payload: data
  };
};

export const getActionForStockSummary_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    departmentID: "",
    accountableID: "",
    projectID: "",
    categoryType: "Procurement",
    categoryID: 27,
    assignedToID: "",
    assignedByID: "",
    statusID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: -1,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return ErpApiService.post(
      ApiPaths.GET_ACTION_FOR_STOCK_SUMMARY,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getActionForStockSummarySuccess(data));
        } else {
          dispatch(getActionForStockSummarySuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getActionForStockSummarySuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getActionForStockSummarySuccess = (data) => {
  return {
    type: GET_ACTION_FOR_STOCK_SUMMARY,
    payload: data
  };
};

//Procurement ORM
export const getProcurmentDataORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    departmentID: "",
    accountableID: "",
    projectID: "",
    categoryType: "Procurement",
    categoryID: 26,
    assignedToID: "",
    assignedByID: "",
    statusID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: -1,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    dispatch(dashBoardLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_PROCUREMENT_DATA_ORM,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        dispatch(dashBoardLoadingFalse());
        if (!data.error) {
          dispatch(getProcurmentDataORMSuccess(data));
        } else {
          dispatch(getProcurmentDataORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getProcurmentDataORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getProcurmentDataORMSuccess = (data) => {
  return {
    type: GET_PROCUREMENT_DATA_ORM,
    payload: data
  };
};

export const getProcurmentSummaryORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    departmentID: "",
    accountableID: "",
    projectID: "",
    categoryType: "",
    categoryID: "",
    assignedToID: "",
    assignedByID: "",
    statusID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: -1,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_PROCUREMENT_SUMMARY_ORM,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getProcurmentSummaryORMSuccess(data));
        } else {
          dispatch(getProcurmentSummaryORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getProcurmentSummaryORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getProcurmentSummaryORMSuccess = (data) => {
  return {
    type: GET_PROCUREMENT_SUMMARY_ORM,
    payload: data
  };
};

export const getProcurmentORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    departmentID: "",
    accountableID: "",
    projectID: "",
    categoryType: "Procurement",
    categoryID: 26,
    assignedToID: "",
    assignedByID: "",
    statusID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: -1,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(ApiPaths.GET_PROCUREMENT_ORM, initialPayload)
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getProcurmentORMSuccess(data));
        } else {
          dispatch(getProcurmentORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getProcurmentORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getProcurmentORMSuccess = (data) => {
  return {
    type: GET_PROCUREMENT_ORM,
    payload: data
  };
};

export const getStoreDataORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    departmentID: "",
    accountableID: "",
    projectID: "",
    categoryType: "Procurement",
    categoryID: 26,
    assignedToID: "",
    assignedByID: "",
    statusID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: -1,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    dispatch(dashBoardLoadingTrue());
    return DashboardService.post(ApiPaths.GET_STORE_DATA_ORM, initialPayload)
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        dispatch(dashBoardLoadingFalse());
        if (!data.error) {
          dispatch(getStoreDataORMSuccess(data));
        } else {
          dispatch(getStoreDataORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getStoreDataORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getStoreDataORMSuccess = (data) => {
  return {
    type: GET_STORE_DATA_ORM,
    payload: data
  };
};

export const getStoreSummaryORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    dataTypeID: "",
    itemID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: -1,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(ApiPaths.GET_STORE_SUMMARY_ORM, initialPayload)
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getStoreSummaryORMSuccess(data));
        } else {
          dispatch(getStoreSummaryORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getStoreSummaryORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getStoreSummaryORMSuccess = (data) => {
  return {
    type: GET_STORE_SUMMARY_ORM,
    payload: data
  };
};

export const getStoreORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: -1,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(ApiPaths.GET_STORE_ORM, initialPayload)
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getStoreORMSuccess(data));
        } else {
          dispatch(getStoreORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getStoreORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getStoreORMSuccess = (data) => {
  return {
    type: GET_STORE_ORM,
    payload: data
  };
};

//Civil
export const getCivilDataORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    departmentID: "",
    accountableID: "",
    projectID: "",
    categoryType: "",
    categoryID: "",
    assignedToID: "",
    assignedByID: "",
    statusID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: -1,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    dispatch(dashBoardLoadingTrue());
    return DashboardService.post(ApiPaths.GET_CIVIL_DATA_ORM, initialPayload)
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        dispatch(dashBoardLoadingFalse());
        if (!data.error) {
          dispatch(getCivilDataORMSuccess(data));
        } else {
          dispatch(getCivilDataORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getCivilDataORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getCivilDataORMSuccess = (data) => {
  return {
    type: GET_CIVIL_DATA_ORM,
    payload: data
  };
};

export const getCivilInitiationDataORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: -1,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    dispatch(dashBoardLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_CIVIL_INITIATION_DATA_ORM,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        dispatch(dashBoardLoadingFalse());
        if (!data.error) {
          dispatch(getCivilInitiationDataORMSuccess(data));
        } else {
          dispatch(getCivilInitiationDataORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getCivilInitiationDataORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getCivilInitiationDataORMSuccess = (data) => {
  return {
    type: GET_CIVIL_INITIATION_DATA_ORM,
    payload: data
  };
};

export const addProjectProgressVideo_action = (data) => {
  let initialPayload;
  initialPayload = new FormData();
  initialPayload.append("userID", LoginuserId);
  initialPayload.append("projectID", data.projectID);
  initialPayload.append("documentFile", data?.documentFile);
  const config = data?.documentFile
    ? {
        headers: { "content-type": "multipart/form-data" }
      }
    : {};
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(
      ApiPaths.ADD_PROJECT_PROGRESS_VIDEO,
      initialPayload,
      config
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          // dispatch(getInsertedLandBrokerId(data.data));
          dispatch(
            displayMessage({
              text: data.message,
              type: "success"
            })
          );
        } else {
          dispatch(
            displayMessage({
              text: data.message,
              type: "success"
            })
          );
        }
      })
      .catch((err) => {
        dispatch(mainLoadingFalse());
      });
  };
};

export const getProjectProgressVideo_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    statusID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: -1,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_PROJECT_PROGRESS_VIDEO,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getProjectProgressVideoSuccess(data));
        } else {
          dispatch(getProjectProgressVideoSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getProjectProgressVideoSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getProjectProgressVideoSuccess = (data) => {
  return {
    type: GET_PROJECT_PROGRESS_VIDEO,
    payload: data
  };
};

//Civil Action ORM
export const getActionForCivilProcess_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    departmentID: "",
    accountableID: "",
    projectID: "",
    categoryType: "Civil",
    categoryID: 24,
    assignedToID: "",
    assignedByID: "",
    statusID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: -1,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return ErpApiService.post(
      ApiPaths.GET_ACTION_FOR_CIVIL_PROCESS,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getActionForCivilProcessSuccess(data));
        } else {
          dispatch(getActionForCivilProcessSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getActionForCivilProcessSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getActionForCivilProcessSuccess = (data) => {
  return {
    type: GET_ACTION_FOR_CIVIL_PROCESS,
    payload: data
  };
};

export const getActionForCivilInitiation_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    departmentID: "",
    accountableID: "",
    projectID: "",
    categoryType: "Civil",
    categoryID: 25,
    assignedToID: "",
    assignedByID: "",
    statusID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: -1,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return ErpApiService.post(
      ApiPaths.GET_ACTION_FOR_CIVIL_INITIATION,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getActionForCivilInitiationSuccess(data));
        } else {
          dispatch(getActionForCivilInitiationSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getActionForCivilInitiationSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getActionForCivilInitiationSuccess = (data) => {
  return {
    type: GET_ACTION_FOR_CIVIL_INITIATION,
    payload: data
  };
};

export const getActionForSchedule_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    departmentID: "",
    accountableID: "",
    projectID: "",
    categoryType: "Civil",
    categoryID: 38,
    assignedToID: "",
    assignedByID: "",
    statusID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: -1,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return ErpApiService.post(ApiPaths.GET_ACTION_FOR_SCHEDULE, initialPayload)
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getActionForScheduleSuccess(data));
        } else {
          dispatch(getActionForScheduleSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getActionForScheduleSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getActionForScheduleSuccess = (data) => {
  return {
    type: GET_ACTION_FOR_SCHEDULE,
    payload: data
  };
};

export const getActionForBudget_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    departmentID: "",
    accountableID: "",
    projectID: "",
    categoryType: "Civil",
    categoryID: 37,
    assignedToID: "",
    assignedByID: "",
    statusID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: -1,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return ErpApiService.post(ApiPaths.GET_ACTION_FOR_BUDGET, initialPayload)
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getActionForBudgetSuccess(data));
        } else {
          dispatch(getActionForBudgetSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getActionForBudgetSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getActionForBudgetSuccess = (data) => {
  return {
    type: GET_ACTION_FOR_BUDGET,
    payload: data
  };
};

export const addOrmRemarks_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,

    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(ApiPaths.ADD_ORM_REMARKS, initialPayload)
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          // toast.success(data.message);
          dispatch(
            displayMessage({
              text: data.message,
              type: "success"
            })
          );
        } else {
          // toast.error(data.message);
          dispatch(
            displayMessage({
              text: data.message,
              type: "error"
            })
          );
        }
      })
      .catch((err) => {
        dispatch(mainLoadingFalse());
      });
  };
};

export const addOrmProjectPlanDate_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,

    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(
      ApiPaths.ADD_ORM_PROJECT_PLAN_DATE,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          // toast.success(data.message);
          dispatch(
            displayMessage({
              text: data.message,
              type: "success"
            })
          );
        } else {
          // toast.error(data.message);
          dispatch(
            displayMessage({
              text: data.message,
              type: "error"
            })
          );
        }
      })
      .catch((err) => {
        dispatch(mainLoadingFalse());
      });
  };
};

export const getHrORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    departmentID: "",
    fromDate: "",
    toDate: "",
    // categoryType: "HR",
    // categoryID: 28,

    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: -1,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(ApiPaths.GET_HR_ORM, initialPayload)
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getHrORMSuccess(data));
        } else {
          dispatch(getHrORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getHrORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getHrORMSuccess = (data) => {
  return {
    type: GET_HR_ORM,
    payload: data
  };
};

export const getActionForHR_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    departmentID: "",
    accountableID: "",
    projectID: "",
    categoryType: "HR",
    categoryID: 28,
    assignedToID: "",
    assignedByID: "",
    statusID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: -1,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return ErpApiService.post(ApiPaths.GET_ACTION_FOR_HR, initialPayload)
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getActionForHRSuccess(data));
        } else {
          dispatch(getActionForHRSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getActionForHRSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getActionForHRSuccess = (data) => {
  return {
    type: GET_ACTION_FOR_HR,
    payload: data
  };
};
export const getActionForCompliance_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    departmentID: "",
    accountableID: "",
    projectID: "",
    categoryType: "Compliance",
    categoryID: 29,
    assignedToID: "",
    assignedByID: "",
    statusID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: -1,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return ErpApiService.post(
      ApiPaths.GET_ACTION_FOR_COMPLIANCE,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getActionForComplianceSuccess(data));
        } else {
          dispatch(getActionForComplianceSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getActionForComplianceSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getActionForComplianceSuccess = (data) => {
  return {
    type: GET_ACTION_FOR_COMPLIANCE,
    payload: data
  };
};
export const getActionForApf_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    departmentID: "",
    accountableID: "",
    projectID: "",
    categoryType: "APF",
    categoryID: 30,
    assignedToID: "",
    assignedByID: "",
    statusID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: -1,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return ErpApiService.post(ApiPaths.GET_ACTION_FOR_APF, initialPayload)
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getActionForApfSuccess(data));
        } else {
          dispatch(getActionForApfSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getActionForApfSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getActionForApfSuccess = (data) => {
  return {
    type: GET_ACTION_FOR_APF,
    payload: data
  };
};

export const getActionForProjectLoan_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    departmentID: "",
    accountableID: "",
    projectID: "",
    categoryType: "ProjectLoan",
    categoryID: 31,
    assignedToID: "",
    assignedByID: "",
    statusID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: -1,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return ErpApiService.post(
      ApiPaths.GET_ACTION_FOR_PROJECT_LOAN,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getActionForProjectLoanSuccess(data));
        } else {
          dispatch(getActionForProjectLoanSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getActionForProjectLoanSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getActionForProjectLoanSuccess = (data) => {
  return {
    type: GET_ACTION_FOR_PROJECT_LOAN,
    payload: data
  };
};

export const getApfTaskPlanReportORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    taskID: "",
    taskStatus: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: -1,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_APF_TASK_PLAN_REPORT_ORM,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getApfTaskPlanReportORMSuccess(data));
        } else {
          dispatch(getApfTaskPlanReportORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getApfTaskPlanReportORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getApfTaskPlanReportORMSuccess = (data) => {
  return {
    type: GET_APF_TASK_PLAN_REPORT_ORM,
    payload: data
  };
};

export const getProjectLoanSummaryORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    financialInstituteID: "",
    status: "",
    sortOrder: "",
    generalSearch: "",
    iDisplayStart: "0",
    iDisplayLength: "-1",
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_PROJECT_LOAN_SUMMARY_ORM,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getProjectLoanSummaryORMSuccess(data));
        } else {
          dispatch(getProjectLoanSummaryORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getProjectLoanSummaryORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getProjectLoanSummaryORMSuccess = (data) => {
  return {
    type: GET_PROJECT_LOAN_SUMMARY_ORM,
    payload: data
  };
};

export const getProcurmentPlanDataORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    financialInstituteID: "",
    statusID: "",
    sortOrder: "",
    generalSearch: "",
    iDisplayStart: "0",
    iDisplayLength: "-1",

    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    dispatch(dashBoardLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_PROCURMENT_PLAN_DATA_ORM,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        dispatch(dashBoardLoadingFalse());
        if (!data.error) {
          dispatch(getProcurmentPlanDataORMSuccess(data));
        } else {
          dispatch(getProcurmentPlanDataORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getProcurmentPlanDataORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getProcurmentPlanDataORMSuccess = (data) => {
  return {
    type: GET_PROCURMENT_PLAN_DATA_ORM,
    payload: data
  };
};

export const getSurveySketchDashboard_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    financialInstituteID: "",
    statusID: "",
    sortOrder: "",
    generalSearch: "",
    iDisplayStart: "0",
    iDisplayLength: "-1",

    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_SURVEY_SKETCH_DASHBOARD,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getSurveySketchDashboardSuccess(data));
        } else {
          dispatch(getSurveySketchDashboardSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getSurveySketchDashboardSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getSurveySketchDashboardSuccess = (data) => {
  return {
    type: GET_SURVEY_SKETCH_DASHBOARD,
    payload: data
  };
};

export const getProcurmentPlanORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,

    projectID: "",
    responsibleID: "",
    accountableID: "",
    generalSearch: "",
    sortOrder: "",
    fromDate: "",
    toDate: "",
    iDisplayStart: 0,
    iDisplayLength: 10,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_PROCURMENT_PLAN_ORM,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getProcurmentPlanORMSuccess(data));
        } else {
          dispatch(getProcurmentPlanORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getProcurmentPlanORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getProcurmentPlanORMSuccess = (data) => {
  return {
    type: GET_PROCURMENT_PLAN_ORM,
    payload: data
  };
};

export const getActionForProcurementOutstanding_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    departmentID: "",
    accountableID: "",
    projectID: "",
    categoryType: "Procurement",
    categoryID: 35,
    assignedToID: "",
    assignedByID: "",
    statusID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: -1,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return ErpApiService.post(
      ApiPaths.GET_ACTION_FOR_PROCUREMENT_OUTSTANDING,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getActionForProcurementOutstandingSuccess(data));
        } else {
          dispatch(getActionForProcurementOutstandingSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getActionForProcurementOutstandingSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getActionForProcurementOutstandingSuccess = (data) => {
  return {
    type: GET_ACTION_FOR_PROCUREMENT_OUTSTANDING,
    payload: data
  };
};

export const getProcurmentPlanSummaryORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    projectId: [],
    itemID: "",

    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: 10,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_PROCURMENT_PLAN_SUMMARY_ORM,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getProcurmentPlanSummaryORMSuccess(data));
        } else {
          dispatch(getProcurmentPlanSummaryORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getProcurmentPlanSummaryORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getProcurmentPlanSummaryORMSuccess = (data) => {
  return {
    type: GET_PROCURMENT_PLAN_SUMMARY_ORM,
    payload: data
  };
};

//Inventory Site ORM
export const getSiteInventoryDataORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    sortOrder: "",
    generalSearch: "",
    iDisplayStart: "0",
    iDisplayLength: "-1",
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    dispatch(dashBoardLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_SITE_INVENTORY_DATA_ORM,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        dispatch(dashBoardLoadingFalse());
        if (!data.error) {
          dispatch(getSiteInventoryDataORMSuccess(data));
        } else {
          dispatch(getSiteInventoryDataORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getSiteInventoryDataORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getSiteInventoryDataORMSuccess = (data) => {
  return {
    type: GET_SITE_INVENTORY_DATA_ORM,
    payload: data
  };
};
export const getSiteInventoryORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    siteStatusID: "",
    sortOrder: "",
    generalSearch: "",
    iDisplayStart: "0",
    iDisplayLength: "-1",

    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_SITE_INVENTORY_ORM,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getSiteInventoryORMSuccess(data));
        } else {
          dispatch(getSiteInventoryORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getSiteInventoryORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getSiteInventoryORMSuccess = (data) => {
  return {
    type: GET_SITE_INVENTORY_ORM,
    payload: data
  };
};
export const getSiteInventoryORMExport_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    siteStatusID: "",
    sortOrder: "",
    generalSearch: "",
    iDisplayStart: "0",
    iDisplayLength: "-1",
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_SITE_INVENTORY_ORM,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getSiteInventoryORMExportSuccess(data));
        } else {
          dispatch(getSiteInventoryORMExportSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getSiteInventoryORMExportSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getSiteInventoryORMExportSuccess = (data) => {
  return {
    type: GET_SITE_INVENTORY_ORM_EXPORT,
    payload: data
  };
};
export const getProjectLandBankORMExport_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    deedType: "",
    isMortgage: "",
    mortgageBankID: "",
    projectID: "",
    villageID: "",
    hobliID: "",
    acquisitionStatus: "",
    projectPhaseID: "",
    planningAuthorityID: "",
    bdOwnerID: "",
    legalOwnerID: "",
    acquisitionReasonID: "",
    projectStatus: "",
    fileStatus: "",
    sortOrder: "",
    generalSearch: "",
    iDisplayStart: "0",
    iDisplayLength: "-1",
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_PROJECT_LAND_BANK_ORM,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getProjectLandBankORMExportSuccess(data));
        } else {
          dispatch(getProjectLandBankORMExportSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getProjectLandBankORMExportSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getProjectLandBankORMExportSuccess = (data) => {
  return {
    type: GET_PROJECT_LAND_BANK_ORM_EXPORT,
    payload: data
  };
};
export const getActionForSiteInventory_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    departmentID: "",
    accountableID: "",
    projectID: "",
    categoryType: "Inventory",
    categoryID: 34,
    assignedToID: "",
    assignedByID: "",
    statusID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: -1,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return ErpApiService.post(
      ApiPaths.GET_ACTION_FOR_SITE_INVENTORY,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getActionForSiteInventorySuccess(data));
        } else {
          dispatch(getActionForSiteInventorySuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getActionForSiteInventorySuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getActionForSiteInventorySuccess = (data) => {
  return {
    type: GET_ACTION_FOR_SITE_INVENTORY,
    payload: data
  };
};
// Inventory Land ORM
export const getProjectLandBankDataORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    deedTypeID: "",
    isMortgage: "",
    projectID: "",
    villageID: "",
    acquisitionStatus: "",
    projectPhaseID: "",
    planningAuthorityID: "",
    acquisitionReasonID: "",

    dataTypeID: "",
    sortOrder: "",
    generalSearch: "",
    iDisplayStart: "0",
    iDisplayLength: "-1",
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    dispatch(dashBoardLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_PROJECT_LAND_BANK_DATA_ORM,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        dispatch(dashBoardLoadingFalse());
        if (!data.error) {
          dispatch(getProjectLandBankDataORMSuccess(data));
        } else {
          dispatch(getProjectLandBankDataORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getProjectLandBankDataORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getProjectLandBankDataORMSuccess = (data) => {
  return {
    type: GET_PROJECT_LAND_BANK_DATA_ORM,
    payload: data
  };
};
export const getProjectLandBankDataORM1_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    deedTypeID: "",
    isMortgage: "",
    projectID: "",
    villageID: "",
    acquisitionStatus: "",
    projectPhaseID: "",
    planningAuthorityID: "",
    acquisitionReasonID: "",

    dataTypeID: "",
    sortOrder: "",
    generalSearch: "",
    iDisplayStart: "0",
    iDisplayLength: "-1",
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_PROJECT_LAND_BANK_DATA_ORM1,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getProjectLandBankDataORM1Success(data));
        } else {
          dispatch(getProjectLandBankDataORM1Success({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getProjectLandBankDataORM1Success([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getProjectLandBankDataORM1Success = (data) => {
  return {
    type: GET_PROJECT_LAND_BANK_DATA_ORM1,
    payload: data
  };
};
export const getProjectLandBankORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    deedType: "",
    isMortgage: "",
    mortgageBankID: "",
    projectID: "",
    villageID: "",
    hobliID: "",
    acquisitionStatus: "",
    projectPhaseID: "",
    planningAuthorityID: "",
    bdOwnerID: "",
    legalOwnerID: "",
    acquisitionReasonID: "",

    projectStatus: "",
    fileStatus: "",
    sortOrder: "",
    generalSearch: "",
    iDisplayStart: "0",
    iDisplayLength: "-1",
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_PROJECT_LAND_BANK_ORM,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getProjectLandBankORMSuccess(data));
        } else {
          dispatch(getProjectLandBankORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getProjectLandBankORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getProjectLandBankORMSuccess = (data) => {
  return {
    type: GET_PROJECT_LAND_BANK_ORM,
    payload: data
  };
};
export const getActionForLandInventory_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    departmentID: "",
    accountableID: "",
    projectID: "",
    categoryType: "Inventory",
    categoryID: 33,
    assignedToID: "",
    assignedByID: "",
    statusID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: -1,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return ErpApiService.post(
      ApiPaths.GET_ACTION_FOR_LAND_BANK_ORM,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getActionForLandInventorySuccess(data));
        } else {
          dispatch(getActionForLandInventorySuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getActionForLandInventorySuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getActionForLandInventorySuccess = (data) => {
  return {
    type: GET_ACTION_FOR_LAND_BANK_ORM,
    payload: data
  };
};
//ORM End

export const getApfTaskPlanQueryORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    projectFileID: "",
    taskID: "",
    panelID: "",
    bankID: "",
    queryOwnerID: "",
    queryAccountableID: "",
    fromDate: "",
    toDate: "",
    queryStatus: "",
    sortOrder: "",
    generalSearch: "",
    iDisplayStart: "0",
    iDisplayLength: "-1",

    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_APF_TASK_PLAN_QUERY_ORM,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getApfTaskPlanQueryORMSuccess(data));
        } else {
          dispatch(getApfTaskPlanQueryORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getApfTaskPlanQueryORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getApfTaskPlanQueryORMSuccess = (data) => {
  return {
    type: GET_APF_TASK_PLAN_QUERY_ORM,
    payload: data
  };
};

export const getApfTaskPlanReportORMExport_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    taskID: "",
    taskStatus: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: -1,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_APF_TASK_PLAN_REPORT_ORM,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getApfTaskPlanReportORMExportSuccess(data));
        } else {
          dispatch(getApfTaskPlanReportORMExportSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getApfTaskPlanReportORMExportSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getApfTaskPlanReportORMExportSuccess = (data) => {
  return {
    type: GET_APF_TASK_PLAN_REPORT_ORM_EXPORT,
    payload: data
  };
};

export const getCivilProjectProgressDataORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: -1,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    dispatch(dashBoardLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_CIVIL_PROJECT_PROGRESS_DATA_ORM,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        dispatch(dashBoardLoadingFalse());
        if (!data.error) {
          dispatch(getCivilProjectProgressDataORMSuccess(data));
        } else {
          dispatch(getCivilProjectProgressDataORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getCivilProjectProgressDataORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getCivilProjectProgressDataORMSuccess = (data) => {
  return {
    type: GET_CIVIL_PROJECT_PROGRESS_DATA_ORM,
    payload: data
  };
};

export const getCivilProjectBudgetDataORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: -1,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    dispatch(dashBoardLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_CIVIL_PROJECT_BUDGET_DATA_ORM,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        dispatch(dashBoardLoadingFalse());
        if (!data.error) {
          dispatch(getCivilProjectBudgetDataORMSuccess(data));
        } else {
          dispatch(getCivilProjectBudgetDataORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getCivilProjectBudgetDataORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getCivilProjectBudgetDataORMSuccess = (data) => {
  return {
    type: GET_CIVIL_PROJECT_BUDGET_DATA_ORM,
    payload: data
  };
};

export const getApfTaskPlanReportPanelORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",

    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_APF_TASK_PLAN_REPORT_PANEL_ORM,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getApfTaskPlanReportPanelORMSuccess(data));
        } else {
          dispatch(getApfTaskPlanReportPanelORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getApfTaskPlanReportPanelORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getApfTaskPlanReportPanelORMSuccess = (data) => {
  return {
    type: GET_APF_TASK_PLAN_REPORT_PANEL_ORM,
    payload: data
  };
};

export const getApfTaskPlanReportBankORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",

    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_APF_TASK_PLAN_REPORT_BANK_ORM,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getApfTaskPlanReportBankORMSuccess(data));
        } else {
          dispatch(getApfTaskPlanReportBankORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getApfTaskPlanReportBankORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getApfTaskPlanReportBankORMSuccess = (data) => {
  return {
    type: GET_APF_TASK_PLAN_REPORT_BANK_ORM,
    payload: data
  };
};

export const getProjectLoanDataORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    financialInstituteID: "",
    statusID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: -1,

    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_PROJECT_LOAN_DATA_ORM,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getProjectLoanDataORMSuccess(data));
        } else {
          dispatch(getProjectLoanDataORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getProjectLoanDataORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getProjectLoanDataORMSuccess = (data) => {
  return {
    type: GET_PROJECT_LOAN_DATA_ORM,
    payload: data
  };
};

export const getCollectionProjectionSummaryOrm_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    dataTypeID: "",
    dependencyID: "",

    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: -1,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_COLLECTION_PROJECTION_SUMMARY_ORM,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getCollectionProjectionSummaryOrmSuccess(data));
        } else {
          dispatch(getCollectionProjectionSummaryOrmSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getCollectionProjectionSummaryOrmSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getCollectionProjectionSummaryOrmSuccess = (data) => {
  return {
    type: GET_COLLECTION_PROJECTION_SUMMARY_ORM,
    payload: data
  };
};

export const getCollectionProjectionOrm_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    dataTypeID: "",
    dependencyID: "",
    fromDate: "",
    toDate: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: -1,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_COLLECTION_PROJECTION_ORM,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getCollectionProjectionOrmSuccess(data));
        } else {
          dispatch(getCollectionProjectionOrmSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getCollectionProjectionOrmSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getCollectionProjectionOrmSuccess = (data) => {
  return {
    type: GET_COLLECTION_PROJECTION_ORM,
    payload: data
  };
};

export const getCollectionProjectionOrmExport_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    dataTypeID: "",
    dependencyID: "",

    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: -1,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_COLLECTION_PROJECTION_ORM,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getCollectionProjectionOrmExportSuccess(data));
        } else {
          dispatch(getCollectionProjectionOrmExportSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getCollectionProjectionOrmExportSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getCollectionProjectionOrmExportSuccess = (data) => {
  return {
    type: GET_COLLECTION_PROJECTION_ORM_EXPORT,
    payload: data
  };
};

export const getQcORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    dataTypeID: "",
    dependencyID: "",

    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: -1,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(ApiPaths.GET_QC_ORM, initialPayload)
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getQcORMSuccess(data));
        } else {
          dispatch(getQcORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getQcORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getQcORMSuccess = (data) => {
  return {
    type: GET_QC_ORM,
    payload: data
  };
};

export const getQcORMExport_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    dataTypeID: "",
    dependencyID: "",

    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: -1,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(ApiPaths.GET_QC_ORM, initialPayload)
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getQcORMExportSuccess(data));
        } else {
          dispatch(getQcORMExportSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getQcORMExportSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getQcORMExportSuccess = (data) => {
  return {
    type: GET_QC_ORM_EXPORT,
    payload: data
  };
};

export const getActionForQc_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    departmentID: "",
    accountableID: "",
    projectID: "",
    categoryType: "CRM",
    categoryID: 39,
    assignedToID: "",
    assignedByID: "",
    statusID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: -1,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return ErpApiService.post(ApiPaths.GET_ACTION_FOR_QC, initialPayload)
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getActionForQcSuccess(data));
        } else {
          dispatch(getActionForQcSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err  ", err);
        dispatch(getActionForQcSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getActionForQcSuccess = (data) => {
  return {
    type: GET_ACTION_FOR_QC,
    payload: data
  };
};

export const getQcDataORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    fromDate: "",
    toDate: "",
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    dispatch(dashBoardLoadingTrue());
    return DashboardService.post(ApiPaths.GET_QC_DATA_ORM, initialPayload)
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        dispatch(dashBoardLoadingFalse());
        if (!data.error) {
          dispatch(getQcDataORMSuccess(data));
        } else {
          dispatch(getQcDataORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getQcDataORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getQcDataORMSuccess = (data) => {
  return {
    type: GET_QC_DATA_ORM,
    payload: data
  };
};

export const getQcSummaryORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    fromDate: "",
    toDate: "",
    dataTypeID: "",
    generalSearch: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: 10,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(ApiPaths.GET_QC_SUMMARY_ORM, initialPayload)
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getQcSummaryORMSuccess(data));
        } else {
          dispatch(getQcSummaryORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getQcSummaryORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getQcSummaryORMSuccess = (data) => {
  return {
    type: GET_QC_SUMMARY_ORM,
    payload: data
  };
};
// Inspection
export const getQcInspectionDataOrm_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    fromDate: "",
    toDate: "",
    projectID: "",
    status: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: -1,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_QC_INSPECTION_DATA_ORM,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getQcInspectionDataOrmSuccess(data));
        } else {
          dispatch(getQcInspectionDataOrmSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getQcInspectionDataOrmSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getQcInspectionDataOrmSuccess = (data) => {
  return {
    type: GET_QC_INSPECTION_DATA_ORM,
    payload: data
  };
};
// Observation
export const getQcObservationDataOrm_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    fromDate: "",
    toDate: "",
    projectID: "",
    status: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: -1,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_QC_OBSERVATION_DATA_ORM,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getQcObservationDataOrmSuccess(data));
        } else {
          dispatch(getQcObservationDataOrmSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getQcObservationDataOrmSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getQcObservationDataOrmSuccess = (data) => {
  return {
    type: GET_QC_OBSERVATION_DATA_ORM,
    payload: data
  };
};
// Training
export const getQcTrainingDataOrm_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    fromDate: "",
    toDate: "",
    projectID: "",
    status: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: -1,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_QC_TRAINING_DATA_ORM,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getQcTrainingDataOrmSuccess(data));
        } else {
          dispatch(getQcTrainingDataOrmSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getQcTrainingDataOrmSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getQcTrainingDataOrmSuccess = (data) => {
  return {
    type: GET_QC_TRAINING_DATA_ORM,
    payload: data
  };
};

// Walkthrough
export const getQcWalkthroughDataORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    fromDate: "",
    toDate: "",
    projectID: "",
    status: "",
    sortOrder: "",
    iDisplayStart: 0,
    iDisplayLength: -1,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_QC_WALKTHROUGH_DATA_ORM,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getQcWalkthroughDataORMSuccess(data));
        } else {
          dispatch(getQcWalkthroughDataORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getQcWalkthroughDataORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getQcWalkthroughDataORMSuccess = (data) => {
  return {
    type: GET_QC_WALKTHROUGH_DATA_ORM,
    payload: data
  };
};

export const getQcInspectionORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    fromDate: "",
    toDate: "",
    projectID: "",
    isFirstPass: "",
    status: "",
    sortOrder: "",
    generalSearch: "",
    iDisplayStart: 0,
    iDisplayLength: -1,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(ApiPaths.GET_QC_INSPECTION_ORM, initialPayload)
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getQcInspectionORMSuccess(data));
        } else {
          dispatch(getQcInspectionORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getQcInspectionORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getQcInspectionORMSuccess = (data) => {
  return {
    type: GET_QC_INSPECTION_ORM,
    payload: data
  };
};

export const getQcObservationORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    fromDate: "",
    toDate: "",
    projectID: "",
    isFirstPass: "",
    status: "",
    sortOrder: "",
    generalSearch: "",
    iDisplayStart: 0,
    iDisplayLength: -1,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_QC_OBSERVATION_ORM,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getQcObservationORMSuccess(data));
        } else {
          dispatch(getQcObservationORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getQcObservationORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getQcObservationORMSuccess = (data) => {
  return {
    type: GET_QC_OBSERVATION_ORM,
    payload: data
  };
};

export const getQcTrainingORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    fromDate: "",
    toDate: "",
    projectID: "",
    isFirstPass: "",
    status: "",
    sortOrder: "",
    generalSearch: "",
    iDisplayStart: 0,
    iDisplayLength: -1,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(ApiPaths.GET_QC_TRAINING_ORM, initialPayload)
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getQcTrainingORMSuccess(data));
        } else {
          dispatch(getQcTrainingORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getQcTrainingORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getQcTrainingORMSuccess = (data) => {
  return {
    type: GET_QC_TRAINING_ORM,
    payload: data
  };
};

export const getQcWalkthroughORM_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    fromDate: "",
    toDate: "",
    projectID: "",
    isFirstPass: "",
    status: "",
    sortOrder: "",
    generalSearch: "",
    iDisplayStart: 0,
    iDisplayLength: -1,
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_QC_WALKTHROUGH_ORM,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getQcWalkthroughORMSuccess(data));
        } else {
          dispatch(getQcWalkthroughORMSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getQcWalkthroughORMSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getQcWalkthroughORMSuccess = (data) => {
  return {
    type: GET_QC_WALKTHROUGH_ORM,
    payload: data
  };
};

export const getAccountInvoiceData_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    companyID: "",
    projectID: "",
    categoryID: "",
    expenseHeadID: "",
    scaleTypeID: "",
    reportByID: "",
    recordCount: "",
    fromDate: "",
    toDate: "",
    sortOrder: "",
    iDisplayLength: "",
    iDisplayStart: "",
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_ACCOUNT_INVOICE_DATA,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getAccountInvoiceDataSuccess(data));
        } else {
          dispatch(getAccountInvoiceDataSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getAccountInvoiceDataSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getAccountInvoiceDataSuccess = (data) => {
  return {
    type: GET_ACCOUNT_INVOICE_DATA,
    payload: data
  };
};

export const getAccountInvoiceSummary_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    companyID: "",
    projectID: "",
    categoryID: "",
    expenseHeadID: "",
    scaleTypeID: "",
    reportByID: "",
    recordCount: "",
    fromDate: "",
    toDate: "",
    sortOrder: "",
    iDisplayLength: "",
    iDisplayStart: "",
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_ACCOUNT_INVOICE_SUMMARY,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getAccountInvoiceSummarySuccess(data));
        } else {
          dispatch(getAccountInvoiceSummarySuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getAccountInvoiceSummarySuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getAccountInvoiceSummarySuccess = (data) => {
  return {
    type: GET_ACCOUNT_INVOICE_SUMMARY,
    payload: data
  };
};

export const getAccountInvoice_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    companyID: "",
    projectID: "",
    categoryID: "",
    expenseHeadID: "",
    scaleTypeID: "",
    recordCount: "",
    reportByID: "",
    vendorID: "",
    fromDate: "",
    toDate: "",
    sortOrder: "",
    generalSearch: "",
    iDisplayLength: "",
    iDisplayStart: "",
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(ApiPaths.GET_ACCOUNT_INVOICE, initialPayload)
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getAccountInvoiceSuccess(data));
        } else {
          dispatch(getAccountInvoiceSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getAccountInvoiceSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getAccountInvoiceSuccess = (data) => {
  return {
    type: GET_ACCOUNT_INVOICE,
    payload: data
  };
};

export const getAccountMarketingData_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    companyID: "",
    projectID: "",
    categoryID: "",
    expenseHeadID: "",
    scaleTypeID: "",
    reportByID: "",
    recordCount: "",
    fromDate: "",
    toDate: "",
    sortOrder: "",
    iDisplayLength: "",
    iDisplayStart: "",
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_ACCOUNT_MARKETING_DATA,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getAccountMarketingDataSuccess(data));
        } else {
          dispatch(getAccountMarketingDataSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getAccountMarketingDataSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getAccountMarketingDataSuccess = (data) => {
  return {
    type: GET_ACCOUNT_MARKETING_DATA,
    payload: data
  };
};

export const getAccountMarketingSummary_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    companyID: "",
    projectID: "",
    categoryID: "",
    expenseHeadID: "",
    scaleTypeID: "",
    reportByID: "",
    recordCount: "",
    fromDate: "",
    toDate: "",
    sortOrder: "",
    iDisplayLength: "",
    iDisplayStart: "",
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_ACCOUNT_MARKETING_SUMMARY,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getAccountMarketingSummarySuccess(data));
        } else {
          dispatch(getAccountMarketingSummarySuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getAccountMarketingSummarySuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getAccountMarketingSummarySuccess = (data) => {
  return {
    type: GET_ACCOUNT_MARKETING_SUMMARY,
    payload: data
  };
};

export const getAccountMarketing_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    companyID: "",
    projectID: "",
    categoryID: "",
    expenseHeadID: "",
    scaleTypeID: "",
    recordCount: "",
    reportByID: "",
    vendorID: "",
    fromDate: "",
    toDate: "",
    sortOrder: "",
    generalSearch: "",
    iDisplayLength: "",
    iDisplayStart: "",
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());
    return DashboardService.post(ApiPaths.GET_ACCOUNT_MARKETING, initialPayload)
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        if (!data.error) {
          dispatch(getAccountMarketingSuccess(data));
        } else {
          dispatch(getAccountMarketingSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getAccountMarketingSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getAccountMarketingSuccess = (data) => {
  return {
    type: GET_ACCOUNT_MARKETING,
    payload: data
  };
};
//CRM User Dashboard
// export const getCrmDepartmentDashboardData_action = (data) => {
//   const initialPayload = {
//     userID: LoginuserId,
//     projectID: "",
//     reportUserID: "",
//     bookingTypeID: "",
//     ...data
//   };

//   return (dispatch) => {
//     dispatch(mainLoadingTrue());
//     dispatch(dashBoardLoadingTrue());
//     return DashboardService.post(
//       ApiPaths.GET_CRM_DEPARTMENT_DASHBOARD_DATA,
//       initialPayload
//     )
//       .then((response) => {
//         const { data } = response;
//         dispatch(mainLoadingFalse());
//         dispatch(dashBoardLoadingFalse());
//         if (!data.error) {
//           dispatch(getCrmDepartmentDashboardDataSuccess(data));
//         } else {
//           dispatch(getCrmDepartmentDashboardDataSuccess([]));
//         }
//       })
//       .catch((err) => {
//         console.log("err", err);
//         dispatch(getCrmDepartmentDashboardDataSuccess([]));
//         dispatch(mainLoadingFalse());
//       });
//   };
// };
// export const getCrmDepartmentDashboardDataSuccess = (data) => {
//   return {
//     type: GET_CRM_DEPARTMENT_DASHBOARD_DATA,
//     payload: data
//   };
// };

export const getCrmDepartmentDashboardData_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    leadType: "",
    ...data
  };

  return (dispatch) => {
    dispatch(mainLoadingTrue());
    dispatch(dashBoardLoadingTrue());
    return DashboardService.post(
      ApiPaths.GET_CRM_DEPARTMENT_DASHBOARD_DATA,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());
        dispatch(dashBoardLoadingFalse());
        if (!data.error) {
          dispatch(getCrmDepartmentDashboardDataSuccess(data));
        } else {
          dispatch(getCrmDepartmentDashboardDataSuccess([]));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getCrmDepartmentDashboardDataSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};

export const getCrmDepartmentDashboardDataSuccess = (data) => {
  return {
    type: GET_CRM_DEPARTMENT_DASHBOARD_DATA,
    payload: data
  };
};

export const getCRMPaymentOutStandingData_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    bookingTypeID: "",
    funcdTypeID: "",
    bankID: "",
    ownerTypeID: "",
    reportUserID: "",
    dependencyID: "",
    generalSearch: "",
    orderParameter: "",
    sortOrder: "",
    iDisplayStart: "0",
    iDisplayLength: "-1",
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());

    return DashboardService.post(
      ApiPaths.GET_CRM_PAYMENT_OUTSTANDING_DATA,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());

        if (!data.error) {
          dispatch(getCRMPaymentOutStandingDataSuccess(data));
        } else {
          dispatch(getCRMPaymentOutStandingDataSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getCRMPaymentOutStandingDataSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getCRMPaymentOutStandingDataSuccess = (data) => {
  return {
    type: GET_CRM_PAYMENT_OUTSTANDING_DATA,
    payload: data
  };
};

export const getCRMPaymentOutStandingSummary_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    bookingTypeID: "",
    funcdTypeID: "",
    bankID: "",
    reportUserID: "",
    dependencyID: "",
    generalSearch: "",
    orderParameter: "",
    sortOrder: "",
    iDisplayStart: "0",
    iDisplayLength: "-1",
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());

    return DashboardService.post(
      ApiPaths.GET_CRM_PAYMENT_OUTSTANDING_SUMMARY,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());

        if (!data.error) {
          dispatch(getCRMPaymentOutStandingSummarySuccess(data));
        } else {
          dispatch(getCRMPaymentOutStandingSummarySuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getCRMPaymentOutStandingSummarySuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getCRMPaymentOutStandingSummarySuccess = (data) => {
  return {
    type: GET_CRM_PAYMENT_OUTSTANDING_SUMMARY,
    payload: data
  };
};

export const getCRMPaymentOutStandingInfo_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    bookingTypeID: "",
    funcdTypeID: "",
    bankID: "",
    reportUserID: "",
    dependencyID: "",
    generalSearch: "",
    orderParameter: "",
    sortOrder: "",
    iDisplayStart: "0",
    iDisplayLength: "-1",
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());

    return DashboardService.post(
      ApiPaths.GET_CRM_PAYMENT_OUTSTANDING_INFO,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());

        if (!data.error) {
          dispatch(getCRMPaymentOutStandingInfoSuccess(data));
        } else {
          dispatch(getCRMPaymentOutStandingInfoSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getCRMPaymentOutStandingInfoSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getCRMPaymentOutStandingInfoSuccess = (data) => {
  return {
    type: GET_CRM_PAYMENT_OUTSTANDING_INFO,
    payload: data
  };
};

export const getCRMPaymentOutStandingDetail_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    bookingTypeID: "",
    funcdTypeID: "",
    bankID: "",
    reportUserID: "",
    dependencyID: "",
    generalSearch: "",
    orderParameter: "",
    sortOrder: "",
    iDisplayStart: "0",
    iDisplayLength: "-1",
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());

    return DashboardService.post(
      ApiPaths.GET_CRM_PAYMENT_OUTSTANDING_DETAIL,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());

        if (!data.error) {
          dispatch(getCRMPaymentOutStandingDetailSuccess(data));
        } else {
          dispatch(getCRMPaymentOutStandingDetailSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getCRMPaymentOutStandingDetailSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getCRMPaymentOutStandingDetailSuccess = (data) => {
  return {
    type: GET_CRM_PAYMENT_OUTSTANDING_DETAIL,
    payload: data
  };
};

export const getCRMPaymentReceivableData_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    bookingTypeID: "",
    funcdTypeID: "",
    bankID: "",
    reportUserID: "",
    dependencyID: "",
    generalSearch: "",
    orderParameter: "",
    sortOrder: "",
    iDisplayStart: "0",
    iDisplayLength: "-1",
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());

    return DashboardService.post(
      ApiPaths.GET_CRM_PAYMENT_RECEIVABLE_DATA,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());

        if (!data.error) {
          dispatch(getCRMPaymentReceivableDataSuccess(data));
        } else {
          dispatch(getCRMPaymentReceivableDataSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getCRMPaymentReceivableDataSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getCRMPaymentReceivableDataSuccess = (data) => {
  return {
    type: GET_CRM_PAYMENT_RECEIVABLE_DATA,
    payload: data
  };
};

export const getCRMPaymentReceivableDetail_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    bookingTypeID: "",
    funcdTypeID: "",
    bankID: "",
    reportUserID: "",
    dependencyID: "",
    generalSearch: "",
    orderParameter: "",
    sortOrder: "",
    iDisplayStart: "0",
    iDisplayLength: "-1",
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());

    return DashboardService.post(
      ApiPaths.GET_CRM_PAYMENT_RECEIVABLE_DETAIL,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());

        if (!data.error) {
          dispatch(getCRMPaymentReceivableDetailSuccess(data));
        } else {
          dispatch(getCRMPaymentReceivableDetailSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getCRMPaymentReceivableDetailSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getCRMPaymentReceivableDetailSuccess = (data) => {
  return {
    type: GET_CRM_PAYMENT_RECEIVABLE_DETAIL,
    payload: data
  };
};

export const getCRMPaymentReceivedData_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    bookingTypeID: "",
    funcdTypeID: "",
    bankID: "",
    reportUserID: "",
    dependencyID: "",
    generalSearch: "",
    orderParameter: "",
    sortOrder: "",
    iDisplayStart: "0",
    iDisplayLength: "-1",
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());

    return DashboardService.post(
      ApiPaths.GET_CRM_PAYMENT_RECEIVED_DATA,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());

        if (!data.error) {
          dispatch(getCRMPaymentReceivedDataSuccess(data));
        } else {
          dispatch(getCRMPaymentReceivedDataSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getCRMPaymentReceivedDataSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getCRMPaymentReceivedDataSuccess = (data) => {
  return {
    type: GET_CRM_PAYMENT_RECEIVED_DATA,
    payload: data
  };
};

export const getCRMPaymentReceivedDetail_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    bookingTypeID: "",
    funcdTypeID: "",
    bankID: "",
    reportUserID: "",
    dependencyID: "",
    generalSearch: "",
    orderParameter: "",
    sortOrder: "",
    iDisplayStart: "0",
    iDisplayLength: "-1",
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());

    return DashboardService.post(
      ApiPaths.GET_CRM_PAYMENT_RECEIVED_DETAIL,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());

        if (!data.error) {
          dispatch(getCRMPaymentReceivedDetailSuccess(data));
        } else {
          dispatch(getCRMPaymentReceivedDetailSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getCRMPaymentReceivedDetailSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getCRMPaymentReceivedDetailSuccess = (data) => {
  return {
    type: GET_CRM_PAYMENT_RECEIVED_DETAIL,
    payload: data
  };
};

export const getCRMPaymentRefund_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    bookingTypeID: "",
    funcdTypeID: "",
    bankID: "",
    reportUserID: "",
    dependencyID: "",
    generalSearch: "",
    orderParameter: "",
    sortOrder: "",
    iDisplayStart: "0",
    iDisplayLength: "-1",
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());

    return DashboardService.post(
      ApiPaths.GET_CRM_PAYMENT_REFUND,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());

        if (!data.error) {
          dispatch(getCRMPaymentRefundSuccess(data));
        } else {
          dispatch(getCRMPaymentRefundSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getCRMPaymentRefundSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getCRMPaymentRefundSuccess = (data) => {
  return {
    type: GET_CRM_PAYMENT_REFUND,
    payload: data
  };
};

export const getCRMPaymentOutStandingItem_action = (data) => {
  const initialPayload = {
    userID: LoginuserId,
    projectID: "",
    bookingTypeID: "",
    funcdTypeID: "",
    bankID: "",
    reportUserID: "",
    dependencyID: "",
    generalSearch: "",
    orderParameter: "",
    sortOrder: "",
    iDisplayStart: "0",
    iDisplayLength: "-1",
    ...data
  };
  return (dispatch) => {
    dispatch(mainLoadingTrue());

    return DashboardService.post(
      ApiPaths.GET_CRM_PAYMENT_OUTSTANDING_ITEM,
      initialPayload
    )
      .then((response) => {
        const { data } = response;
        dispatch(mainLoadingFalse());

        if (!data.error) {
          dispatch(getCRMPaymentOutStandingItemSuccess(data));
        } else {
          dispatch(getCRMPaymentOutStandingItemSuccess({}));
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(getCRMPaymentOutStandingItemSuccess([]));
        dispatch(mainLoadingFalse());
      });
  };
};
export const getCRMPaymentOutStandingItemSuccess = (data) => {
  return {
    type: GET_CRM_PAYMENT_OUTSTANDING_ITEM,
    payload: data
  };
};
